export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: string | Date | null | undefined | import("luxon").DateTime<boolean>; output: string | Date | null | undefined | import("luxon").DateTime<boolean>; }
  AWSEmail: { input: string; output: string; }
  AWSJSON: { input: unknown; output: unknown; }
};

export type AddCommentInput = {
  jobId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  videoTime: Scalars['Int']['input'];
  watchMode?: InputMaybe<WatchMode>;
};

export type AddMomentInput = {
  clipType: ClipType;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Float']['input'];
  importance?: InputMaybe<Scalars['Int']['input']>;
  isNonSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  momentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<Scalars['String']['input']>;
  source: MomentSourceInput;
  speakerId?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['Float']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  trackId: Scalars['ID']['input'];
  visibleToConsumer: Scalars['Boolean']['input'];
};

export type AddReactionInput = {
  jobId: Scalars['ID']['input'];
  reaction: InputReactionName;
  videoTime: Scalars['Int']['input'];
  watchMode: WatchMode;
};

export type AddReplyInput = {
  jobId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type AddTrackInput = {
  jobId: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  momentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  speakerId?: InputMaybe<Scalars['ID']['input']>;
  type: ClipType;
  visibleToConsumer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminGetJobsFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateRangeFilter>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  durationInMs?: InputMaybe<NumericRangeFilter>;
  feature?: InputMaybe<JobFeatureFilterInput>;
  publicSafetyCaseId?: InputMaybe<Scalars['String']['input']>;
  speciality?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobStatusFilterInput>;
  videoType?: InputMaybe<Scalars['String']['input']>;
};

export type AdminGetJobsSortInput = {
  field: AdminJobOrderByOption;
  order: Order;
};

export type AdminGetUsersFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
};

export const AdminJobOrderByOption = {
  CreatedAt: 'createdAt',
  DurationInMs: 'durationInMs',
  LastUpdatedAt: 'lastUpdatedAt',
  MomentCount: 'momentCount',
  OwnerName: 'ownerName',
  Title: 'title',
  UploaderName: 'uploaderName'
} as const;

export type AdminJobOrderByOption = typeof AdminJobOrderByOption[keyof typeof AdminJobOrderByOption];
export type AgencyAdminAgency = {
  __typename?: 'AgencyAdminAgency';
  agencyDomain: Scalars['String']['output'];
  agencyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  /**
   * Organization-wide fallback speciality: applies to any member with no override of their own.
   * Set through adminSetOrgDefaultJobSpeciality.
   */
  defaultJobSpeciality?: Maybe<JobSpeciality>;
  lastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  libraries: Array<AgencyAdminLibrary>;
  officers: Array<AgencyAdminOfficer>;
  orgId: Scalars['ID']['output'];
  /**
   * Organization-level processing defaults and report-feature settings. Always present: an unset
   * boolean on the Organization row reads as false here rather than as null.
   */
  organizationSettings: AgencyOrganizationSettings;
  /** The most recent of those private uploads. Every library row carries its own; so does this. */
  privateLastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /**
   * Uploads that live in no library at all (a private My-Uploads job). They belong to the agency but
   * to none of its libraries, so `libraries` + this is what adds up to `uploadsCount`.
   */
  privateUploadsCount: Scalars['Int']['output'];
  program: Scalars['AWSJSON']['output'];
  reportDictionary: Array<ReportDictionaryRule>;
  /**
   * Generation of the report dictionary; 0 before the first edit. An editor must hand this back as
   * `expectedVersion` so a stale form cannot silently replace someone else's newer save.
   */
  reportDictionaryVersion: Scalars['Int']['output'];
  /**
   * Every format the agency owns, each with its own dictionary. Includes formats trained through
   * the Train wizard on an officer's own library, which the sponsor flow never registers.
   */
  reportFormats: Array<AgencyReportFormat>;
  rosterSize: Scalars['Int']['output'];
  /** The agency's registered report format, if any. Null means no format has been trained yet. */
  sourceCustomSpecialtyId?: Maybe<Scalars['ID']['output']>;
  sponsorEmail?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  sponsorUserId: Scalars['ID']['output'];
  swornOfficersCount: Scalars['Int']['output'];
  /**
   * What CLIPr read out of the agency's sample: letterhead, typeface, page geometry, footer.
   * Resolved here rather than fetched by the client, because getCustomSpecialty is gated on
   * ViewTeam of the template team and an admin reviewing someone else's agency is not a member
   * of it -- the client call returns nothing for exactly the people this page exists for.
   *
   * Its own type, not CustomSpecialty: that one carries the generated prompt and the sample's
   * storage key, and this field is reached under assertCanViewAgency, which admits anyone who can
   * see the agency console. Returning the whole row would hand every one of them a field selection
   * ViewTeam is supposed to gate.
   */
  trainedFormat?: Maybe<AgencyTrainedFormat>;
  uploadsCount: Scalars['Int']['output'];
  /** Template row version, so an editor can send it back as `expectedVersion` when saving. */
  version: Scalars['Int']['output'];
  vocabulary: Array<Vocabulary>;
};

export type AgencyAdminLibrary = {
  __typename?: 'AgencyAdminLibrary';
  externalEmail?: Maybe<Scalars['String']['output']>;
  lastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  name: Scalars['String']['output'];
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
  uploadsCount: Scalars['Int']['output'];
};

export type AgencyAdminListFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  hasUploads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgencyAdminListSortInput = {
  field: AgencyAdminOrderByOption;
  order: Order;
};

export type AgencyAdminOfficer = {
  __typename?: 'AgencyAdminOfficer';
  email: Scalars['AWSEmail']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  section: Scalars['String']['output'];
  supervisorEmail?: Maybe<Scalars['AWSEmail']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  supervisorTitle?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uploadsCount: Scalars['Int']['output'];
};

export const AgencyAdminOrderByOption = {
  AgencyName: 'agencyName',
  CreatedAt: 'createdAt',
  LastUploadAt: 'lastUploadAt',
  LibraryCount: 'libraryCount',
  SponsorEmail: 'sponsorEmail',
  UploadsCount: 'uploadsCount'
} as const;

export type AgencyAdminOrderByOption = typeof AgencyAdminOrderByOption[keyof typeof AgencyAdminOrderByOption];
export type AgencyAdminSummary = {
  __typename?: 'AgencyAdminSummary';
  agencyDomain: Scalars['String']['output'];
  agencyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  invitedCount: Scalars['Int']['output'];
  lastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  libraryCount: Scalars['Int']['output'];
  orgId: Scalars['ID']['output'];
  rosterSize: Scalars['Int']['output'];
  sponsorEmail?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  sponsorUserId: Scalars['ID']['output'];
  uploadsCount: Scalars['Int']['output'];
};

export type AgencyAdminSummaryConnection = {
  __typename?: 'AgencyAdminSummaryConnection';
  edges: Array<AgencyAdminSummaryEdge>;
  pageInfo: PageInfo;
};

export type AgencyAdminSummaryEdge = {
  __typename?: 'AgencyAdminSummaryEdge';
  cursor: Scalars['String']['output'];
  node: AgencyAdminSummary;
};

export type AgencyDetailsInput = {
  agencyName: Scalars['String']['input'];
  bwcPlatform?: InputMaybe<Scalars['String']['input']>;
  /**
   * Version of the template the editor was populated from. The write is rejected if the row moved
   * on since, so a form left open while someone else saves cannot silently overwrite them. Omitted
   * means "whatever is current", which only an unattended caller should want.
   */
  expectedVersion?: InputMaybe<Scalars['Int']['input']>;
  mdtManufacturer?: InputMaybe<Scalars['String']['input']>;
  mdtModel?: InputMaybe<Scalars['String']['input']>;
  mdtPurchaseWindow: MdtPurchaseWindow;
  reseller?: InputMaybe<Scalars['String']['input']>;
  resellerPocEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  resellerPocName?: InputMaybe<Scalars['String']['input']>;
  rmsPlatform?: InputMaybe<Scalars['String']['input']>;
  swornOfficersCount: Scalars['Int']['input'];
};

export type AgencyInviteAllResult = {
  __typename?: 'AgencyInviteAllResult';
  errors: Array<AgencyInviteLibraryError>;
  teams: Array<Team>;
};

export type AgencyInviteLibraryError = {
  __typename?: 'AgencyInviteLibraryError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  officerEmail: Scalars['AWSEmail']['output'];
};

export type AgencyOfficerRow = {
  email: Scalars['AWSEmail']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  supervisorEmail: Scalars['AWSEmail']['input'];
  supervisorName: Scalars['String']['input'];
  supervisorTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AgencyOfficerStat = {
  __typename?: 'AgencyOfficerStat';
  avgTimeToCertifySeconds?: Maybe<Scalars['Int']['output']>;
  lastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  teamId: Scalars['ID']['output'];
  uploadsCount: Scalars['Int']['output'];
};

/**
 * The organization's processing defaults and report-feature settings.
 *
 * A bounded object rather than more flat fields on AgencyAdminAgency: these are the settings a save
 * commits together, so the mutation can answer with exactly them and the page can fold the answer back
 * in without rebuilding the whole agency.
 *
 * Deliberately NOT the organization's default speciality. That one has its own editor and its own
 * mutation (`adminSetOrgDefaultJobSpeciality`), which checks the Organization row rather than an
 * AgencyTemplate -- most production organizations have no template, and this object is reachable only
 * for the ones that do.
 *
 * Booleans are non-null here even though the stored attribute is optional -- absent means false, and
 * resolving that once on the server keeps every caller from having to know it.
 */
export type AgencyOrganizationSettings = {
  __typename?: 'AgencyOrganizationSettings';
  /** Generate a Customer Follow-Up Letter when an eligible report is certified. */
  customerFollowUpLetterEnabled: Scalars['Boolean']['output'];
  /** Agency-wide Dual+ default. A library that sets its own still wins. */
  dualPlusEnabled: Scalars['Boolean']['output'];
  /** Use phonetic normalization when processing addresses for this organization. */
  phoneticAddressNormalizationEnabled: Scalars['Boolean']['output'];
  /** True means new uploads skip video transcode and visual analysis. Existing jobs are untouched. */
  videoDisabled: Scalars['Boolean']['output'];
};

export type AgencyOrganizationSettingsInput = {
  customerFollowUpLetterEnabled: Scalars['Boolean']['input'];
  dualPlusEnabled: Scalars['Boolean']['input'];
  phoneticAddressNormalizationEnabled: Scalars['Boolean']['input'];
  videoDisabled: Scalars['Boolean']['input'];
};

/**
 * What a dictionary save committed, and nothing else.
 * Deliberately not the whole agency: that payload is assembled from Elasticsearch aggregations and a
 * read per library, so a blip in any of them turned a write that had already landed into an error --
 * and the editor, still holding its pre-save generation, could not retry it.
 */
export type AgencyReportDictionarySaved = {
  __typename?: 'AgencyReportDictionarySaved';
  orgId: Scalars['ID']['output'];
  reportDictionary: Array<ReportDictionaryRule>;
  /** Hand this back as `expectedVersion` on the next save of the same list. */
  reportDictionaryVersion: Scalars['Int']['output'];
  /** The format the rules landed on. Null means they went to the agency-wide list. */
  specialtyId?: Maybe<Scalars['ID']['output']>;
};

/**
 * A report format the agency owns, and its own dictionary.
 *
 * Crawford writes for many carriers, and each wants its own wording -- "member" for one, "customer"
 * for the next -- so the rules belong to the format, not to the agency. One list per agency would be
 * the transcript dictionary again.
 */
export type AgencyReportFormat = {
  __typename?: 'AgencyReportFormat';
  /** True for the format the sponsor registered through the agency sample flow. */
  isAgencySource: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reportDictionary: Array<ReportDictionaryRule>;
  /** Generation of this format's dictionary; hand it back as `expectedVersion` when saving. */
  reportDictionaryVersion: Scalars['Int']['output'];
  specialtyId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
  /** The library it was trained in, so two formats with the same name can be told apart. */
  teamName?: Maybe<Scalars['String']['output']>;
};

export type AgencySampleUploadTicket = {
  __typename?: 'AgencySampleUploadTicket';
  expiresAt: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  ticketId: Scalars['ID']['output'];
  uploadFields: Scalars['AWSJSON']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type AgencySignupDraft = {
  __typename?: 'AgencySignupDraft';
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['AWSJSON']['output'];
  updatedAt: Scalars['String']['output'];
};

export type AgencySignupPayload = {
  acceptedTerms: Scalars['Boolean']['input'];
  agencyDomain: Scalars['String']['input'];
  agencyName: Scalars['String']['input'];
  bwcPlatform: Scalars['String']['input'];
  mdtManufacturer: Scalars['String']['input'];
  mdtModel: Scalars['String']['input'];
  mdtPurchaseWindow: MdtPurchaseWindow;
  officers: Array<AgencyOfficerRow>;
  reseller: Scalars['String']['input'];
  resellerPocEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  resellerPocName?: InputMaybe<Scalars['String']['input']>;
  rmsPlatform: Scalars['String']['input'];
  /**
   * Partner landing page this signup came from (e.g. /panasonicmdt,
   * /reasonsweserve). The server routes the HubSpot marketing form
   * accordingly; omitted means the default agency signup form.
   */
  source?: InputMaybe<AgencySignupSource>;
  sponsorEmail: Scalars['AWSEmail']['input'];
  sponsorFirstName: Scalars['String']['input'];
  sponsorLastName: Scalars['String']['input'];
  sponsorPassword: Scalars['String']['input'];
  sponsorPhone?: InputMaybe<Scalars['String']['input']>;
  sponsorTitle: Scalars['String']['input'];
  swornOfficersCount: Scalars['Int']['input'];
};

export type AgencySignupResult = {
  __typename?: 'AgencySignupResult';
  agencyTemplateId: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
  sponsorUserId: Scalars['ID']['output'];
};

export const AgencySignupSource = {
  Panasonic: 'PANASONIC',
  ReasonsWeServe: 'REASONS_WE_SERVE'
} as const;

export type AgencySignupSource = typeof AgencySignupSource[keyof typeof AgencySignupSource];
export type AgencyTemplate = {
  __typename?: 'AgencyTemplate';
  agencyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  extras: Scalars['AWSJSON']['output'];
  hubspotCompanyId?: Maybe<Scalars['String']['output']>;
  hubspotCompanyStatus?: Maybe<Scalars['String']['output']>;
  hubspotContactId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  libraryTeamIds: Array<Scalars['ID']['output']>;
  officerEmailToTeamId: Scalars['AWSJSON']['output'];
  officers: Scalars['AWSJSON']['output'];
  orgId: Scalars['ID']['output'];
  perTeamCustomSpecialtyIds: Scalars['AWSJSON']['output'];
  program: Scalars['AWSJSON']['output'];
  samplePoliceReportS3Key?: Maybe<Scalars['String']['output']>;
  sampleUploadTickets: Scalars['AWSJSON']['output'];
  sourceCustomSpecialtyId?: Maybe<Scalars['ID']['output']>;
  sponsorUserId: Scalars['ID']['output'];
  swornOfficersCount: Scalars['Int']['output'];
  templateTeamId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** The reading of an agency's sample that admin is allowed to see. Presentation only. */
export type AgencyTrainedFormat = {
  __typename?: 'AgencyTrainedFormat';
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  footerHtml?: Maybe<Scalars['String']['output']>;
  logoInches?: Maybe<ReportSizeInches>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  pageMarginInches?: Maybe<ReportPageMargins>;
  pageSizeInches?: Maybe<ReportSizeInches>;
  sampleReportS3Key?: Maybe<Scalars['String']['output']>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ApiKeyConnection = {
  __typename?: 'ApiKeyConnection';
  edges: Array<ApiKeyEdge>;
  pageInfo: PageInfo;
};

export type ApiKeyEdge = {
  __typename?: 'ApiKeyEdge';
  cursor: Scalars['String']['output'];
  node: ApiKey;
};

export type ArchiveResponse = {
  __typename?: 'ArchiveResponse';
  archivedId: Scalars['String']['output'];
};

export type AssetExport = {
  __typename?: 'AssetExport';
  downloadUrl: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
};

export type AssetMedia = {
  __typename?: 'AssetMedia';
  basic?: Maybe<Scalars['String']['output']>;
  enSubtitle?: Maybe<Scalars['String']['output']>;
  hls?: Maybe<ProtectedUrl>;
  liveStreamUrl?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type AssetShareLink = {
  __typename?: 'AssetShareLink';
  expiresInSeconds: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type Bookmark = {
  __typename?: 'Bookmark';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
  jobStub?: Maybe<BookmarkJobStub>;
  listId: Scalars['ID']['output'];
  momentId?: Maybe<Scalars['ID']['output']>;
  momentStub?: Maybe<BookmarkMomentStub>;
  thumbnail?: Maybe<Array<ResizedImage>>;
};


export type BookmarkThumbnailArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type BookmarkConnection = {
  __typename?: 'BookmarkConnection';
  edges: Array<BookmarkEdge>;
  pageInfo: PageInfo;
};

export type BookmarkEdge = {
  __typename?: 'BookmarkEdge';
  cursor: Scalars['String']['output'];
  node: Bookmark;
};

export type BookmarkJobStub = {
  __typename?: 'BookmarkJobStub';
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BookmarkList = {
  __typename?: 'BookmarkList';
  bookmarkCount: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
  thumbnails?: Maybe<Array<Maybe<Array<ResizedImage>>>>;
};


export type BookmarkListThumbnailsArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type BookmarkMomentStub = {
  __typename?: 'BookmarkMomentStub';
  clipType: ClipType;
  momentType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChangeJobOwnerInput = {
  jobId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export const ClientApp = {
  Consumer: 'Consumer',
  Trainer: 'Trainer'
} as const;

export type ClientApp = typeof ClientApp[keyof typeof ClientApp];
export const ClipType = {
  ActionItem: 'ActionItem',
  Chapter: 'Chapter',
  Moment: 'Moment',
  Paragraph: 'Paragraph',
  SubTopic: 'SubTopic',
  Topic: 'Topic',
  Transcript: 'Transcript'
} as const;

export type ClipType = typeof ClipType[keyof typeof ClipType];
export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  reaction?: Maybe<OutputReactionName>;
  text?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserStub>;
  userId: Scalars['ID']['output'];
  videoTime: Scalars['Float']['output'];
  watchMode?: Maybe<WatchMode>;
};

export type CommentConnection = {
  __typename?: 'CommentConnection';
  edges: Array<CommentEdge>;
  pageInfo: PageInfo;
};

export type CommentEdge = {
  __typename?: 'CommentEdge';
  cursor: Scalars['String']['output'];
  node: Comment;
};

export type CompleteMultipartUploadInput = {
  eTags: Array<Scalars['String']['input']>;
  uploadId: Scalars['String']['input'];
  uploadToken: Scalars['String']['input'];
};

export type CompleteMultipartUploadPayload = {
  __typename?: 'CompleteMultipartUploadPayload';
  uploadId: Scalars['String']['output'];
};

export type ConfirmSpeakerPredictionInput = {
  jobId: Scalars['ID']['input'];
  speakerId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  trackId: Scalars['ID']['input'];
};

export type ConnectExternalLibraryInput = {
  authorizationCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  source: ExternalLibrarySource;
};

export type ConnectExternalLibraryPayload = {
  __typename?: 'ConnectExternalLibraryPayload';
  externalLibrary: ExternalLibrary;
  viewer?: Maybe<Viewer>;
};

export type Cookie = {
  __typename?: 'Cookie';
  domain: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CreateAssetShareLinkInput = {
  asset: ShareableAssetType;
  format?: InputMaybe<ExportFormat>;
  jobId: Scalars['ID']['input'];
};

export type CreateCustomSpecialtyInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sampleReportFileName: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};

export type CreateCustomSpecialtyPayload = {
  __typename?: 'CreateCustomSpecialtyPayload';
  customSpecialty: CustomSpecialty;
  uploadFields: Array<FormDataField>;
  uploadUrl: Scalars['String']['output'];
};

export type CreateMachineClientInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateMachineClientResponse = {
  __typename?: 'CreateMachineClientResponse';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type CreateMediaShortLinkInput = {
  asset: ShareableAssetType;
  jobId: Scalars['ID']['input'];
};

export type CreateMultiPartUploadInput = {
  fileName: Scalars['String']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  numberOfParts: Scalars['Int']['input'];
  partIndex?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateMultiPartUploadPayload = {
  __typename?: 'CreateMultiPartUploadPayload';
  signedUrls: Array<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
  uploadToken: Scalars['String']['output'];
};

export type CreateNotificationSubscriptionInput = {
  destination: Scalars['String']['input'];
  subscribedEvents: Array<NotificationSubscriptionSubscribedEvent>;
  uploadProgressOptions?: InputMaybe<UploadProgressOptionsInput>;
};

export type CreateVideoShortLinkInput = {
  customRedirect?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  params?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomSpecialty = {
  __typename?: 'CustomSpecialty';
  /** Whether the immediately previous trained prompt can be restored. */
  canRevert?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Page furniture recovered from the sample .docx. Exposed so the editor can show a draft in the
   * customer's own typography and page geometry, matching what the export will produce.
   */
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  footerHtml?: Maybe<Scalars['String']['output']>;
  generatedPrompt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoInches?: Maybe<ReportSizeInches>;
  /** Presigned URL for the letterhead. Short-lived, so it is resolved per request. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pageMarginInches?: Maybe<ReportPageMargins>;
  pageSizeInches?: Maybe<ReportSizeInches>;
  /** Structure summary recovered from the sample, shown beside the prompt in the wizard. */
  parsedSampleStructure?: Maybe<Scalars['String']['output']>;
  /**
   * Bumped by every successful training run. Training is asynchronous, so this is what tells a
   * caller that the prompt it is looking at came from its own run rather than the previous one.
   */
  promptVersion?: Maybe<Scalars['Int']['output']>;
  reportDictionary?: Maybe<Array<ReportDictionaryRule>>;
  sampleReportS3Key?: Maybe<Scalars['String']['output']>;
  /**
   * Presigned URL for the sample this format was trained from, so a sponsor can check which
   * document is actually in effect. Short-lived, resolved per request.
   */
  sampleReportUrl?: Maybe<Scalars['String']['output']>;
  status: CustomSpecialtyStatus;
  teamId: Scalars['ID']['output'];
  /** Exemplar generation currently reflected in generatedPrompt. */
  trainedTrainingDataVersion?: Maybe<Scalars['Int']['output']>;
  /** Changes whenever the ready exemplar set changes. */
  trainingDataVersion?: Maybe<Scalars['Int']['output']>;
  /**
   * Why the last training run failed, cleared when the next one starts. Set only by the worker:
   * the run outlives the request that asked for it, so the record is where the outcome lands.
   */
  trainingError?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  version: Scalars['Int']['output'];
};

export const CustomSpecialtyStatus = {
  Active: 'Active',
  Archived: 'Archived',
  Draft: 'Draft'
} as const;

export type CustomSpecialtyStatus = typeof CustomSpecialtyStatus[keyof typeof CustomSpecialtyStatus];
export type CustomSpecialtyTrainingData = {
  __typename?: 'CustomSpecialtyTrainingData';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['ID']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initial?: Maybe<Scalars['Boolean']['output']>;
  role: CustomSpecialtyTrainingDataRole;
  specialtyId: Scalars['ID']['output'];
  status: CustomSpecialtyTrainingDataStatus;
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export const CustomSpecialtyTrainingDataRole = {
  Exemplar: 'Exemplar',
  Initial: 'Initial',
  Reference: 'Reference'
} as const;

export type CustomSpecialtyTrainingDataRole = typeof CustomSpecialtyTrainingDataRole[keyof typeof CustomSpecialtyTrainingDataRole];
export const CustomSpecialtyTrainingDataStatus = {
  Pending: 'Pending',
  Ready: 'Ready',
  Removed: 'Removed'
} as const;

export type CustomSpecialtyTrainingDataStatus = typeof CustomSpecialtyTrainingDataStatus[keyof typeof CustomSpecialtyTrainingDataStatus];
export type DateRangeFilter = {
  gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DeceptioAiAnalysis = {
  __typename?: 'DeceptioAiAnalysis';
  id: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type DeceptioAiDetailedAnalysis = {
  __typename?: 'DeceptioAiDetailedAnalysis';
  id: Scalars['String']['output'];
  results: Array<DeceptioAiRuleResult>;
  score: Scalars['Int']['output'];
  tokensUsed?: Maybe<Scalars['Int']['output']>;
};

export type DeceptioAiRuleResult = {
  __typename?: 'DeceptioAiRuleResult';
  description: Scalars['String']['output'];
  followupQuestions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ranges: Array<Array<Scalars['Int']['output']>>;
};

export type DeleteCommentResponse = {
  __typename?: 'DeleteCommentResponse';
  id: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
};

export type DeleteExternalLibraryInput = {
  externalLibraryId: Scalars['ID']['input'];
};

export type DeleteExternalLibraryPayload = {
  __typename?: 'DeleteExternalLibraryPayload';
  deletedExternalLibrary: ExternalLibrary;
  viewer?: Maybe<Viewer>;
};

export type DeleteMachineClientInput = {
  clientId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteMomentInput = {
  jobId: Scalars['ID']['input'];
  momentId: Scalars['ID']['input'];
};

export type DeleteNotificationsSubscriptionSubscribedEventInput = {
  subscribedEvent: NotificationSubscriptionSubscribedEvent;
  token: Scalars['String']['input'];
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  deletedId: Scalars['String']['output'];
};

export type DeleteTeamInvitationResponse = {
  __typename?: 'DeleteTeamInvitationResponse';
  email: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
};

export type DeleteTeamMemberResponse = {
  __typename?: 'DeleteTeamMemberResponse';
  teamId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type DeletedOrganizationIdResponse = {
  __typename?: 'DeletedOrganizationIDResponse';
  id: Scalars['ID']['output'];
};

export type DeletedTeamIdResponse = {
  __typename?: 'DeletedTeamIDResponse';
  teamId: Scalars['ID']['output'];
};

export const DualPlusReportStatus = {
  Complete: 'Complete',
  Failed: 'Failed',
  Generating: 'Generating'
} as const;

export type DualPlusReportStatus = typeof DualPlusReportStatus[keyof typeof DualPlusReportStatus];
export type EditCommentInput = {
  commentId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type ExportClipsInput = {
  bookmarkListId: Scalars['String']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
};

export const ExportDisposition = {
  Attachment: 'Attachment',
  Inline: 'Inline'
} as const;

export type ExportDisposition = typeof ExportDisposition[keyof typeof ExportDisposition];
export const ExportFormat = {
  Docx: 'DOCX',
  Pdf: 'PDF'
} as const;

export type ExportFormat = typeof ExportFormat[keyof typeof ExportFormat];
export type ExportJobAssetInput = {
  asset: ShareableAssetType;
  format: ExportFormat;
  jobId: Scalars['ID']['input'];
};

export type ExportJobOutput = {
  __typename?: 'ExportJobOutput';
  executionArn: Scalars['String']['output'];
};

export type ExportTextEditorPdfInput = {
  /**
   * How the browser should treat the returned URL. Defaults to a download; `inline` is for
   * viewing the document in a tab, which is what printing does.
   */
  disposition?: InputMaybe<ExportDisposition>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  html: Scalars['String']['input'];
  /**
   * Source job. Used only to reapply the team's custom-specialty branding (letterhead,
   * running footer, typography) to the export; omit for an unbranded document.
   */
  jobId?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type ExportTextEditorPdfResult = {
  __typename?: 'ExportTextEditorPdfResult';
  downloadUrl: Scalars['String']['output'];
  expiresInSeconds: Scalars['Int']['output'];
};

export type ExternalLibrary = {
  __typename?: 'ExternalLibrary';
  files?: Maybe<LibraryFileConnection>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  source: ExternalLibrarySource;
};


export type ExternalLibraryFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalLibraryFilesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ExternalLibraryFilesSortInput>;
};

export type ExternalLibraryFilesFilterInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export const ExternalLibraryFilesOrderByOption = {
  ModifiedTime: 'modifiedTime',
  Name: 'name'
} as const;

export type ExternalLibraryFilesOrderByOption = typeof ExternalLibraryFilesOrderByOption[keyof typeof ExternalLibraryFilesOrderByOption];
export type ExternalLibraryFilesSortInput = {
  field: ExternalLibraryFilesOrderByOption;
  order: Order;
};

export const ExternalLibrarySource = {
  GoogleDrive: 'GoogleDrive',
  OneDrive: 'OneDrive',
  TeamOneDrive: 'TeamOneDrive',
  Zoom: 'Zoom'
} as const;

export type ExternalLibrarySource = typeof ExternalLibrarySource[keyof typeof ExternalLibrarySource];
export type FormDataField = {
  __typename?: 'FormDataField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export const GalleryDisplay = {
  Carousel: 'Carousel',
  Grid: 'Grid',
  List: 'List'
} as const;

export type GalleryDisplay = typeof GalleryDisplay[keyof typeof GalleryDisplay];
export type GenerateDualPlusPublicSafetyReportInput = {
  jobId: Scalars['ID']['input'];
};

export type GeneratePromptPayload = {
  __typename?: 'GeneratePromptPayload';
  customSpecialty: CustomSpecialty;
  extractedStructure?: Maybe<Scalars['String']['output']>;
};

export const GenerativeAiProvider = {
  Amazon: 'Amazon',
  OpenAi: 'OpenAi'
} as const;

export type GenerativeAiProvider = typeof GenerativeAiProvider[keyof typeof GenerativeAiProvider];
export type GenerativeAiSettings = {
  __typename?: 'GenerativeAiSettings';
  actionItemsExtractionEnabled?: Maybe<Scalars['Boolean']['output']>;
  cliprGptEnabled?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<GenerativeAiProvider>;
  summarizationEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type GenerativeAiSettingsInput = {
  actionItemsExtractionEnabled: Scalars['Boolean']['input'];
  cliprGptEnabled: Scalars['Boolean']['input'];
  provider: GenerativeAiProvider;
  summarizationEnabled: Scalars['Boolean']['input'];
};

export type GetCommentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
};

export type GetDownloadLinkInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  jobId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Float']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetGptAnswerInput = {
  distinctJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetGptAnswerMetadata = {
  __typename?: 'GetGPTAnswerMetadata';
  endTime?: Maybe<Scalars['Float']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Float']['output']>;
  subtopicId?: Maybe<Scalars['String']['output']>;
  subtopicThumbnail?: Maybe<Array<ResizedImage>>;
};


export type GetGptAnswerMetadataSubtopicThumbnailArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type GetGptAnswerOutput = {
  __typename?: 'GetGPTAnswerOutput';
  metadata?: Maybe<Array<Maybe<GetGptAnswerMetadata>>>;
  result: Scalars['String']['output'];
};

export type GetInvitationsFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TeamMemberRole>;
};

export type GetInvitationsSortInput = {
  field: InvitationByOption;
  order: Order;
};

export type GetJobsFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  allJobs?: InputMaybe<Scalars['Boolean']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<MetadataFilterInput>>;
  publicSafetyCaseId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<JobSourceType>;
  speciality?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobStatusFilterInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  videoType?: InputMaybe<Scalars['String']['input']>;
  visibleToTeams?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetJobsSortInput = {
  field: JobOrderByOption;
  order: Order;
};

export type GetNotificationsSubscriptionsFilterInput = {
  subscribedEvent?: InputMaybe<NotificationSubscriptionSubscribedEvent>;
};

export type GetReactionsFilterInput = {
  watchMode?: InputMaybe<Array<InputMaybe<WatchMode>>>;
};

export type GetReactionsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetReactionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
};

export type GetTeamMembersFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TeamMemberRole>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type GetTeamMembersSortInput = {
  field: TeamMembersByOption;
  order: Order;
};

export const GetTeamScope = {
  Admin: 'Admin',
  Default: 'Default'
} as const;

export type GetTeamScope = typeof GetTeamScope[keyof typeof GetTeamScope];
export type GetTeamsFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<GetTeamScope>;
  teamNamespace?: InputMaybe<Scalars['String']['input']>;
  teamProduct?: InputMaybe<TeamProduct>;
};

export type GetTeamsSortInput = {
  field: TeamOrderByOption;
  order: Order;
};

export type Highlight = {
  __typename?: 'Highlight';
  field: Scalars['String']['output'];
  snippets: Array<Scalars['String']['output']>;
};

export type IamRoleInput = {
  region?: InputMaybe<Scalars['String']['input']>;
  roleArn: Scalars['String']['input'];
};

export type ImageSize = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportJobOutput = {
  __typename?: 'ImportJobOutput';
  executionArn: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
};

export const Industry = {
  AccomodationFoodServices: 'AccomodationFoodServices',
  AdministrationBusinessWasteServices: 'AdministrationBusinessWasteServices',
  AgricultureForestryFishingHunting: 'AgricultureForestryFishingHunting',
  ArtsEntertainmentRecreation: 'ArtsEntertainmentRecreation',
  Construction: 'Construction',
  EducationalServices: 'EducationalServices',
  FinanceInsurance: 'FinanceInsurance',
  HealthcareSocialAssistance: 'HealthcareSocialAssistance',
  Information: 'Information',
  Manufacturing: 'Manufacturing',
  Mining: 'Mining',
  OtherServices: 'OtherServices',
  ProfessionalScientificTechnicalServices: 'ProfessionalScientificTechnicalServices',
  PublicSafety: 'PublicSafety',
  RealEstateRentalLeasing: 'RealEstateRentalLeasing',
  RetailTrade: 'RetailTrade',
  TransportationWarehousing: 'TransportationWarehousing',
  Utilities: 'Utilities',
  WholesaleTrade: 'WholesaleTrade'
} as const;

export type Industry = typeof Industry[keyof typeof Industry];
export const IngestError = {
  DownloadFailed: 'DownloadFailed',
  ProcessingFailed: 'ProcessingFailed'
} as const;

export type IngestError = typeof IngestError[keyof typeof IngestError];
export const InputReactionName = {
  Confusing: 'Confusing',
  Engaging: 'Engaging',
  Fire: 'Fire',
  Funny: 'Funny',
  Genius: 'Genius',
  Love: 'Love'
} as const;

export type InputReactionName = typeof InputReactionName[keyof typeof InputReactionName];
export const InvitationByOption = {
  Email: 'email',
  Role: 'role'
} as const;

export type InvitationByOption = typeof InvitationByOption[keyof typeof InvitationByOption];
export type InviteTeamMemberResponse = {
  __typename?: 'InviteTeamMemberResponse';
  invitation?: Maybe<TeamInvitation>;
  member?: Maybe<TeamMember>;
};

export type Job = {
  __typename?: 'Job';
  availableGptProviders?: Maybe<Array<GenerativeAiProvider>>;
  complianceScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customSpecialtyId?: Maybe<Scalars['ID']['output']>;
  customerFollowUpLetterPending?: Maybe<Scalars['Boolean']['output']>;
  deceptioSpeakerId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detectiveInsights?: Maybe<Scalars['String']['output']>;
  durationInMs?: Maybe<Scalars['Int']['output']>;
  enSubtitleLocation?: Maybe<Scalars['String']['output']>;
  features: JobFeatures;
  hostilityScore?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  ingestError?: Maybe<Scalars['String']['output']>;
  ingestExecutionArn?: Maybe<Scalars['String']['output']>;
  inputDocumentLocations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  languageCode?: Maybe<Scalars['String']['output']>;
  lastView?: Maybe<Scalars['AWSDateTime']['output']>;
  liveStream?: Maybe<LiveStream>;
  media?: Maybe<AssetMedia>;
  medicalSpecialty?: Maybe<MedicalSpecialty>;
  metadata?: Maybe<Metadata>;
  momentCount?: Maybe<Scalars['Int']['output']>;
  originalDocumentLocation?: Maybe<Scalars['String']['output']>;
  originalDocumentName?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Owner>;
  ownerId: Scalars['String']['output'];
  poster?: Maybe<Array<ResizedImage>>;
  progressPercentage?: Maybe<Scalars['Int']['output']>;
  publicSafetyCaseId?: Maybe<Scalars['String']['output']>;
  publicSafetyCustomerFollowUpLetter?: Maybe<Scalars['String']['output']>;
  publicSafetyDualPlusReport?: Maybe<Scalars['String']['output']>;
  publicSafetyDualPlusReportStartedAt?: Maybe<Scalars['String']['output']>;
  publicSafetyDualPlusReportStatus?: Maybe<DualPlusReportStatus>;
  publicSafetyEditResumedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  publicSafetyEditSessionId?: Maybe<Scalars['ID']['output']>;
  publicSafetyEditSessionStartedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  publicSafetyLastEditedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  publicSafetyManualReport?: Maybe<Scalars['String']['output']>;
  publicSafetyNotes?: Maybe<Scalars['String']['output']>;
  publicSafetyNotesFeedback?: Maybe<Scalars['String']['output']>;
  publicSafetyOfficerName?: Maybe<Scalars['String']['output']>;
  publicSafetyOfficerTitle?: Maybe<Scalars['String']['output']>;
  publicSafetyOriginalReportUrl?: Maybe<Scalars['String']['output']>;
  publicSafetyReport?: Maybe<Scalars['String']['output']>;
  publicSafetyReportChanged?: Maybe<Scalars['Boolean']['output']>;
  publicSafetyReportComplete?: Maybe<Scalars['Boolean']['output']>;
  publicSafetyReportCompleteAt?: Maybe<Scalars['AWSDateTime']['output']>;
  publicSafetyReportDiff?: Maybe<Scalars['String']['output']>;
  publicSafetyReportFeedback?: Maybe<Scalars['String']['output']>;
  publicSafetyReportRevising?: Maybe<Scalars['Boolean']['output']>;
  recordingLocation?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  redactionRequest?: Maybe<RedactionRequest>;
  relatedPublicSafetyJobs?: Maybe<Array<Job>>;
  /**
   * Quotations in the generated report that the transcript does not support.
   *
   * The report dictionary instructs the model to leave quoted speech alone, which is an instruction
   * rather than a guarantee -- a live run was observed rewriting a witness's words. Empty means every
   * quotation long enough to matter appears verbatim in the transcript; it does not mean the report
   * is accurate. Computed on read, so it costs nothing unless asked for.
   */
  reportQuoteIssues?: Maybe<Array<ReportQuoteIssue>>;
  skipVideo?: Maybe<Scalars['Boolean']['output']>;
  slideDeckUrl?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  source: JobSource;
  sourceLanguageCode?: Maybe<Scalars['String']['output']>;
  speciality?: Maybe<JobSpeciality>;
  status: JobStatus;
  subtitleLocation?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  targetLanguageCode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translatedDocument?: Maybe<Scalars['String']['output']>;
  translatedDocumentLocation?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  userPermissions?: Maybe<Array<UserJobPermission>>;
  videoType?: Maybe<JobType>;
  viewCount?: Maybe<Scalars['Int']['output']>;
  visibleToTeams?: Maybe<Array<Team>>;
};


export type JobPosterArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};


export type JobPublicSafetyReportDiffArgs = {
  suggestionDetail?: InputMaybe<Scalars['Int']['input']>;
};


export type JobSortOrderArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type JobConnection = {
  __typename?: 'JobConnection';
  edges: Array<JobEdge>;
  pageInfo: PageInfo;
};

export type JobEdge = {
  __typename?: 'JobEdge';
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Highlight>>;
  node: Job;
};

export type JobFeatureFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export const JobFeatureStatus = {
  Done: 'Done',
  Fail: 'Fail',
  NotRequested: 'NotRequested',
  Pending: 'Pending',
  Processing: 'Processing'
} as const;

export type JobFeatureStatus = typeof JobFeatureStatus[keyof typeof JobFeatureStatus];
export type JobFeatures = {
  __typename?: 'JobFeatures';
  automaticEnrichment: JobFeatureStatus;
  manualEnrichment: JobFeatureStatus;
  media: JobFeatureStatus;
  transcript: JobFeatureStatus;
};

export type JobLanguage = {
  __typename?: 'JobLanguage';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export const JobOrderByOption = {
  CreatedAt: 'createdAt',
  DurationInMs: 'durationInMs',
  MomentCount: 'momentCount',
  Scheduled: 'scheduled',
  ScheduledDateTime: 'scheduledDateTime',
  Score: 'score',
  SortOrder: 'sortOrder',
  Title: 'title'
} as const;

export type JobOrderByOption = typeof JobOrderByOption[keyof typeof JobOrderByOption];
export const JobOriginalSourceType = {
  ExternalLibrary: 'ExternalLibrary',
  Live: 'Live',
  Upload: 'Upload',
  Url: 'Url'
} as const;

export type JobOriginalSourceType = typeof JobOriginalSourceType[keyof typeof JobOriginalSourceType];
export type JobPermission = {
  __typename?: 'JobPermission';
  jobId: Scalars['String']['output'];
  role: JobPermissionRole;
  teamId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export const JobPermissionRole = {
  Editor: 'Editor',
  Owner: 'Owner',
  Viewer: 'Viewer'
} as const;

export type JobPermissionRole = typeof JobPermissionRole[keyof typeof JobPermissionRole];
export type JobSource = {
  __typename?: 'JobSource';
  externalId?: Maybe<Scalars['String']['output']>;
  externalLibrary?: Maybe<JobSourceExternalLibrary>;
  jobId?: Maybe<Scalars['String']['output']>;
  liveCliprHLS?: Maybe<Scalars['Boolean']['output']>;
  liveStreamActivePlaylist?: Maybe<LiveStreamActivePlaylist>;
  liveStreamUrl?: Maybe<Scalars['String']['output']>;
  originalType?: Maybe<JobOriginalSourceType>;
  password?: Maybe<Scalars['String']['output']>;
  type: JobSourceType;
  url?: Maybe<Scalars['String']['output']>;
};

export type JobSourceExternalLibrary = {
  __typename?: 'JobSourceExternalLibrary';
  externalLibraryId: Scalars['ID']['output'];
  fileId: Scalars['ID']['output'];
  source: ExternalLibrarySource;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
};

export type JobSourceExternalLibraryInput = {
  externalLibraryId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
  source: ExternalLibrarySource;
};

export type JobSourceInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalLibrary?: InputMaybe<JobSourceExternalLibraryInput>;
  password?: InputMaybe<Scalars['String']['input']>;
  type: JobSourceType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export const JobSourceType = {
  Copy: 'Copy',
  ExternalLibrary: 'ExternalLibrary',
  Live: 'Live',
  Upload: 'Upload',
  Url: 'Url'
} as const;

export type JobSourceType = typeof JobSourceType[keyof typeof JobSourceType];
export const JobSpeciality = {
  ComplianceBehavioralAnalyst: 'ComplianceBehavioralAnalyst',
  Custom: 'Custom',
  DocumentTranslation: 'DocumentTranslation',
  FirstDraft: 'FirstDraft',
  FraudInvestigation: 'FraudInvestigation',
  InsuranceLossAdjuster: 'InsuranceLossAdjuster',
  InternalAffairsInterviewFirstDraft: 'InternalAffairsInterviewFirstDraft',
  InterviewRoom: 'InterviewRoom',
  Medical: 'Medical',
  PepPreEmploymentInterview: 'PEPPreEmploymentInterview',
  PatrolAiSuggestions: 'PatrolAiSuggestions',
  PsychEval: 'PsychEval',
  PublicSafety: 'PublicSafety',
  QuoteToEstimate: 'QuoteToEstimate',
  RedactionAsAService: 'RedactionAsAService',
  SelfServiceBwcRedaction: 'SelfServiceBWCRedaction',
  Standard: 'Standard',
  WarrantFirstDraft: 'WarrantFirstDraft'
} as const;

export type JobSpeciality = typeof JobSpeciality[keyof typeof JobSpeciality];
export const JobStatus = {
  Done: 'Done',
  Failed: 'Failed',
  InProgress: 'InProgress',
  InReview: 'InReview',
  LiveEnded: 'LiveEnded',
  LiveReady: 'LiveReady',
  LiveStreaming: 'LiveStreaming',
  Pending: 'Pending',
  Updated: 'Updated',
  Waiting: 'Waiting'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
export type JobStatusFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export const JobStatusUpdateOptions = {
  Done: 'Done',
  InReview: 'InReview',
  Updated: 'Updated',
  Waiting: 'Waiting'
} as const;

export type JobStatusUpdateOptions = typeof JobStatusUpdateOptions[keyof typeof JobStatusUpdateOptions];
export type JobThumbnailUploadInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export const JobType = {
  AllHandsMeeting: 'AllHandsMeeting',
  BodyWornCamera: 'BodyWornCamera',
  Class: 'Class',
  Meeting: 'Meeting',
  Other: 'Other',
  Panel: 'Panel',
  Presentation: 'Presentation',
  Webinar: 'Webinar'
} as const;

export type JobType = typeof JobType[keyof typeof JobType];
export const KeenAnalysisType = {
  Average: 'average',
  Count: 'count',
  CountUnique: 'count_unique',
  Maximum: 'maximum',
  Median: 'median',
  Minimum: 'minimum',
  Percentile: 'percentile',
  SelectUnique: 'select_unique',
  StandardDeviation: 'standard_deviation',
  Sum: 'sum'
} as const;

export type KeenAnalysisType = typeof KeenAnalysisType[keyof typeof KeenAnalysisType];
export type KeenBatchInput = {
  end: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type KeenBatchResult = {
  __typename?: 'KeenBatchResult';
  avgWatchTime?: Maybe<KeenQueryResult>;
  bookmarks?: Maybe<KeenQueryResult>;
  edits?: Maybe<KeenQueryResult>;
  hoursCliprdProcessed?: Maybe<KeenQueryResult>;
  hoursCliprdSaved?: Maybe<KeenQueryResult>;
  hoursCliprdViewed?: Maybe<KeenQueryResult>;
  mostBookmarkedSubtopics?: Maybe<KeenQueryResult>;
  mostBookmarkedTopics?: Maybe<KeenQueryResult>;
  plays?: Maybe<KeenQueryResult>;
  reactions?: Maybe<KeenQueryResult>;
  reactionsByJobSource?: Maybe<KeenQueryResult>;
  subTopicViews?: Maybe<KeenQueryResult>;
  teamUserBookmarks?: Maybe<KeenQueryResult>;
  teamUserEdits?: Maybe<KeenQueryResult>;
  teamUserReactions?: Maybe<KeenQueryResult>;
  teamUserUploads?: Maybe<KeenQueryResult>;
  topicViews?: Maybe<KeenQueryResult>;
  totalBookmarks?: Maybe<KeenQueryResult>;
  totalDailyReactions?: Maybe<KeenQueryResult>;
  totalPlays?: Maybe<KeenQueryResult>;
  totalReactions?: Maybe<KeenQueryResult>;
  totalShares?: Maybe<KeenQueryResult>;
  totalTopics?: Maybe<KeenQueryResult>;
  totalUniqueUploads?: Maybe<KeenQueryResult>;
  uploads?: Maybe<KeenQueryResult>;
  userReactions?: Maybe<KeenQueryResult>;
  videoAddToTeam?: Maybe<KeenQueryResult>;
  videoShares?: Maybe<KeenQueryResult>;
  views?: Maybe<KeenQueryResult>;
};

export const KeenCollection = {
  ClipBookmark: 'clipBookmark',
  ClipEdited: 'clipEdited',
  CommentInput: 'commentInput',
  Player: 'player',
  PlayerMetrics: 'playerMetrics',
  PlayerReaction: 'playerReaction',
  VideoAddToTeam: 'videoAddToTeam',
  VideoIngested: 'videoIngested',
  VideoShare: 'videoShare',
  VideoUpload: 'videoUpload'
} as const;

export type KeenCollection = typeof KeenCollection[keyof typeof KeenCollection];
export type KeenFilterInput = {
  operand: KeenFilterOperator;
  propertyName: Scalars['String']['input'];
  propertyValue: Array<InputMaybe<Scalars['String']['input']>>;
};

export const KeenFilterOperator = {
  Contains: 'contains',
  Eq: 'eq',
  Exists: 'exists',
  Gt: 'gt',
  Gte: 'gte',
  In: 'in',
  Lt: 'lt',
  Lte: 'lte',
  Ne: 'ne',
  NotContains: 'not_contains',
  Or: 'or',
  Regex: 'regex',
  Within: 'within'
} as const;

export type KeenFilterOperator = typeof KeenFilterOperator[keyof typeof KeenFilterOperator];
export type KeenOrderBy = {
  direction?: InputMaybe<KeenOrderDirection>;
  propertyName?: InputMaybe<Scalars['String']['input']>;
};

export const KeenOrderDirection = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type KeenOrderDirection = typeof KeenOrderDirection[keyof typeof KeenOrderDirection];
export type KeenQueryInput = {
  analysisType: KeenAnalysisType;
  eventCollection: KeenCollection;
  filters?: InputMaybe<Array<InputMaybe<KeenFilterInput>>>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeMetadata?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<KeenOrderBy>;
  timeframe: KeenTimeframe;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tragetProperty?: InputMaybe<Scalars['String']['input']>;
};

export type KeenQueryResult = {
  __typename?: 'KeenQueryResult';
  result: Scalars['String']['output'];
};

export type KeenTimeframe = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

export type LibraryFile = {
  __typename?: 'LibraryFile';
  canDownload?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  durationInMs?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  job?: Maybe<Job>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  processing?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type LibraryFileConnection = {
  __typename?: 'LibraryFileConnection';
  edges?: Maybe<Array<LibraryFileEdge>>;
  invalidCredentials?: Maybe<Scalars['Boolean']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type LibraryFileEdge = {
  __typename?: 'LibraryFileEdge';
  node: LibraryFile;
};

export type LiveJobSourceInput = {
  liveStreamActivePlaylist?: InputMaybe<LiveStreamActivePlaylist>;
  liveStreamUrl?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  useCliprHLS?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LiveStream = {
  __typename?: 'LiveStream';
  backupIngestUrl: Scalars['String']['output'];
  backupStreamKey: Scalars['String']['output'];
  ingestType?: Maybe<LiveStreamIngestType>;
  ingestUrl: Scalars['String']['output'];
  playlists: LiveStreamPlaylist;
  recordings?: Maybe<LiveStreamRecordings>;
  scheduledDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  streamEnd?: Maybe<Scalars['String']['output']>;
  streamKey: Scalars['String']['output'];
  streamStart?: Maybe<Scalars['String']['output']>;
};

export const LiveStreamActivePlaylist = {
  External: 'External',
  Primary: 'Primary',
  Secondary: 'Secondary'
} as const;

export type LiveStreamActivePlaylist = typeof LiveStreamActivePlaylist[keyof typeof LiveStreamActivePlaylist];
export const LiveStreamChannels = {
  Primary: 'Primary',
  Secondary: 'Secondary'
} as const;

export type LiveStreamChannels = typeof LiveStreamChannels[keyof typeof LiveStreamChannels];
export const LiveStreamIngestType = {
  Automatic: 'Automatic',
  Manual: 'Manual'
} as const;

export type LiveStreamIngestType = typeof LiveStreamIngestType[keyof typeof LiveStreamIngestType];
export type LiveStreamPlaylist = {
  __typename?: 'LiveStreamPlaylist';
  external?: Maybe<Scalars['String']['output']>;
  primary: Scalars['String']['output'];
  primaryActive?: Maybe<Scalars['Boolean']['output']>;
  secondary: Scalars['String']['output'];
  secondaryActive?: Maybe<Scalars['Boolean']['output']>;
};

export type LiveStreamRecordings = {
  __typename?: 'LiveStreamRecordings';
  primary?: Maybe<Scalars['Boolean']['output']>;
  secondary?: Maybe<Scalars['Boolean']['output']>;
};

export type MsTeamChannelInput = {
  channelId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  ingestOption: MsTeamIngestOption;
  teamId: Scalars['String']['input'];
};

export const MsTeamIngestOption = {
  All: 'All',
  Newest: 'Newest'
} as const;

export type MsTeamIngestOption = typeof MsTeamIngestOption[keyof typeof MsTeamIngestOption];
export type MsTeamWebhook = {
  __typename?: 'MSTeamWebhook';
  channelId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  deltaToken: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ingestOption: MsTeamIngestOption;
  subscriptionId: Scalars['String']['output'];
  teamId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type MsTeamWebhookInput = {
  channels: Array<MsTeamChannelInput>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type MachineClient = {
  __typename?: 'MachineClient';
  clientId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export const MdtPurchaseWindow = {
  Last_3Months: 'LAST_3_MONTHS',
  Next_3Months: 'NEXT_3_MONTHS',
  NotSure: 'NOT_SURE'
} as const;

export type MdtPurchaseWindow = typeof MdtPurchaseWindow[keyof typeof MdtPurchaseWindow];
export type MediaShortLink = {
  __typename?: 'MediaShortLink';
  url: Scalars['String']['output'];
};

export const MedicalSpecialty = {
  Primarycare: 'PRIMARYCARE'
} as const;

export type MedicalSpecialty = typeof MedicalSpecialty[keyof typeof MedicalSpecialty];
export type Metadata = {
  __typename?: 'Metadata';
  endTime?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  track?: Maybe<Scalars['String']['output']>;
};

export type MetadataFilterInput = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MetadataInput = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  publishDate?: InputMaybe<Scalars['String']['input']>;
  session?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  track?: InputMaybe<Scalars['String']['input']>;
};

export const MobileEntitlementSource = {
  Personal: 'personal',
  Team: 'team'
} as const;

export type MobileEntitlementSource = typeof MobileEntitlementSource[keyof typeof MobileEntitlementSource];
export const MobileMediaType = {
  Audio: 'audio',
  Video: 'video'
} as const;

export type MobileMediaType = typeof MobileMediaType[keyof typeof MobileMediaType];
export type MobileMediaUsage = {
  __typename?: 'MobileMediaUsage';
  includedRemaining: Scalars['Int']['output'];
  maxCapacityRemaining: Scalars['Int']['output'];
  usedThisCycle: Scalars['Int']['output'];
};

export const MobilePlanTier = {
  Freemium: 'freemium',
  Professional: 'professional',
  Standard: 'standard'
} as const;

export type MobilePlanTier = typeof MobilePlanTier[keyof typeof MobilePlanTier];
export type MobileTeamPurchasePreparation = {
  __typename?: 'MobileTeamPurchasePreparation';
  appUserId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
};

export type MobileUsage = {
  __typename?: 'MobileUsage';
  audio: MobileMediaUsage;
  video: MobileMediaUsage;
};

export type MobileUsageSummary = {
  __typename?: 'MobileUsageSummary';
  cycleEnd?: Maybe<Scalars['AWSDateTime']['output']>;
  cycleStart?: Maybe<Scalars['AWSDateTime']['output']>;
  freemiumHoursRemaining?: Maybe<Scalars['Float']['output']>;
  planTier: MobilePlanTier;
  source: MobileEntitlementSource;
  teamId?: Maybe<Scalars['ID']['output']>;
  usage: MobileUsage;
};

export type Moment = {
  __typename?: 'Moment';
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  clipType: ClipType;
  confidence?: Maybe<MomentConfidence>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['ID']['output'];
  deceptioAiAnalysis?: Maybe<DeceptioAiAnalysis>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  importance?: Maybe<Scalars['Int']['output']>;
  isNonSpeech?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Job>;
  jobId: Scalars['ID']['output'];
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  languageCode?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt: Scalars['AWSDateTime']['output'];
  lastUpdatedBy: Scalars['ID']['output'];
  metadata?: Maybe<MomentMetadata>;
  momentType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  source: MomentSource;
  speakerId?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Array<ResizedImage>>;
  trackId: Scalars['ID']['output'];
  userPermissions?: Maybe<Array<UserMomentPermission>>;
  visibleToConsumer: Scalars['Boolean']['output'];
  wordConfidence?: Maybe<Array<MomentWordConfidence>>;
};


export type MomentThumbnailArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type MomentConfidence = {
  __typename?: 'MomentConfidence';
  avg: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type MomentConnection = {
  __typename?: 'MomentConnection';
  edges: Array<MomentEdge>;
  pageInfo: PageInfo;
};

export type MomentEdge = {
  __typename?: 'MomentEdge';
  cursor: Scalars['String']['output'];
  node: Moment;
};

export type MomentLink = {
  __typename?: 'MomentLink';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['ID']['output'];
  source: MomentNode;
  target: MomentNode;
  type: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type MomentLinkConnection = {
  __typename?: 'MomentLinkConnection';
  edges: Array<MomentLinkEdge>;
  pageInfo: PageInfo;
};

export type MomentLinkEdge = {
  __typename?: 'MomentLinkEdge';
  cursor: Scalars['String']['output'];
  node: MomentLink;
};

export type MomentMetadata = {
  __typename?: 'MomentMetadata';
  extractor?: Maybe<Scalars['String']['output']>;
};

export type MomentNode = {
  __typename?: 'MomentNode';
  jobId: Scalars['ID']['output'];
  jobStub?: Maybe<MomentNodeJobStub>;
  momentId: Scalars['ID']['output'];
};

export type MomentNodeInput = {
  jobId: Scalars['String']['input'];
  momentId: Scalars['String']['input'];
};

export type MomentNodeJobStub = {
  __typename?: 'MomentNodeJobStub';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export const MomentSource = {
  Clipr: 'Clipr',
  Trainer: 'Trainer',
  User: 'User'
} as const;

export type MomentSource = typeof MomentSource[keyof typeof MomentSource];
export const MomentSourceInput = {
  Trainer: 'Trainer',
  User: 'User'
} as const;

export type MomentSourceInput = typeof MomentSourceInput[keyof typeof MomentSourceInput];
export type MomentTypeFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
};

export type MomentWordConfidence = {
  __typename?: 'MomentWordConfidence';
  confidence: Scalars['Float']['output'];
  word: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateCustomSpecialty: CustomSpecialty;
  addAgencyOfficer: AgencyTemplate;
  addComment: Comment;
  addJobToTeam: Scalars['Boolean']['output'];
  addMoment: Moment;
  addMomentLink: MomentLink;
  addReaction: Comment;
  addReply: Comment;
  addSpeaker: Speaker;
  addTrack: Track;
  addVideoType: Settings;
  adminAddOfficerToAgency: Team;
  /** @deprecated Use inviteTeamMember with skipEmail = true instead. */
  adminAddUserToTeam: InviteTeamMemberResponse;
  adminCreateMachineClient: CreateMachineClientResponse;
  adminDeleteMachineClient: DeleteResponse;
  /**
   * Hard-deletes the agency: library teams (+members/invitations),
   * AgencyTemplate, Organization (+org-member links), org-domain sentinel
   * (so the same domain can sign up again), sponsor User row, and Auth0
   * identity. Returns the deleted orgId. IRREVERSIBLE.
   */
  adminHardDeleteAgency: Scalars['ID']['output'];
  adminSetDefaultJobSpeciality: User;
  adminSetOrgDefaultJobSpeciality: Organization;
  /**
   * Clone the agency's registered report format into every officer library that
   * predates it (the clone otherwise only runs at library creation). Idempotent:
   * libraries already on a Custom format are left untouched. Returns the libraries
   * that were newly synced.
   */
  adminSyncAgencyLibraries: Array<Team>;
  adminUpdateAgencyDetails: AgencyAdminAgency;
  adminUpdateAgencyOfficer: AgencyAdminAgency;
  adminUpdateAgencyReportDictionary: AgencyReportDictionarySaved;
  /**
   * Write the agency's organization-level settings. Answers with the committed settings and nothing
   * else -- rebuilding an AgencyAdminAgency here would re-run three OpenSearch aggregations and a
   * read per library to return a payload the caller already has.
   *
   * Only the Organization row is written. Processing defaults affect future uploads; Customer
   * Follow-Up Letter enablement is checked when an eligible report is certified.
   */
  adminUpdateAgencySettings: AgencyOrganizationSettings;
  adminUpdateAgencyVocabulary: AgencyAdminAgency;
  archiveCustomSpecialty: CustomSpecialty;
  archiveJob: ArchiveResponse;
  changeJobOwner: Job;
  completeMultipartUpload: CompleteMultipartUploadPayload;
  confirmAgencySampleReportUpload: AgencyTemplate;
  confirmCustomSpecialtyTrainingDataUpload: CustomSpecialtyTrainingData;
  confirmSpeakerPrediction: Scalars['Boolean']['output'];
  connectExternalLibrary: ConnectExternalLibraryPayload;
  copyJob: Job;
  createApiKey: ApiKey;
  createAssetShareLink: AssetShareLink;
  createBookmark: Bookmark;
  createBookmarkList: BookmarkList;
  createCustomSpecialty: CreateCustomSpecialtyPayload;
  createMediaShortLink: MediaShortLink;
  createMultipartUpload: CreateMultiPartUploadPayload;
  createNotificationsSubscription: NotificationsSubscription;
  createOpenidConfig: OpenidConfig;
  createOrganization: Organization;
  createTeam: Team;
  createVideoShortLink: VideoShortLink;
  deleteApiKey?: Maybe<Scalars['Boolean']['output']>;
  deleteBookmark: DeleteResponse;
  deleteBookmarkList: DeleteResponse;
  deleteComment: DeleteCommentResponse;
  deleteExternalLibrary: DeleteExternalLibraryPayload;
  deleteMoment: DeleteResponse;
  deleteMomentLink: MomentLink;
  deleteNotificationsSubscription: DeleteResponse;
  deleteNotificationsSubscriptionSubscribedEvent: NotificationsSubscription;
  deleteOpenidConfig?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganization: DeletedOrganizationIdResponse;
  deleteSpeaker: DeleteResponse;
  deleteTeam: DeletedTeamIdResponse;
  deleteTeamInvitation: DeleteTeamInvitationResponse;
  deleteTeamMember: DeleteTeamMemberResponse;
  deleteTrack: DeleteResponse;
  deleteVideoType: Settings;
  duplicateTrack: Track;
  editComment: Comment;
  exportClips: Scalars['Boolean']['output'];
  exportJob: ExportJobOutput;
  exportJobAsset: AssetExport;
  exportTextEditorPdf: ExportTextEditorPdfResult;
  generateCustomSpecialtyPrompt: GeneratePromptPayload;
  generateDualPlusPublicSafetyReport: Job;
  getAvatarUploadUrl: PresignedPost;
  getCoverUploadUrl: PresignedPost;
  getGPTAnswer: GetGptAnswerOutput;
  getJobThumbnailUploadURL: PresignedPost;
  getLogoUploadUrl: PresignedPost;
  getProfilePictureUploadUrl: PresignedPost;
  getReportImageUploadUrl: ReportImageUpload;
  getSpeakerPictureUploadUrl: PresignedPost;
  importJob: ImportJobOutput;
  incrementViewCount: Job;
  inviteAgencyLibrary: Team;
  inviteAllAgencyLibraries: AgencyInviteAllResult;
  inviteTeamMember: InviteTeamMemberResponse;
  joinTeamByInvitation: TeamMember;
  leaveTeam?: Maybe<Scalars['Boolean']['output']>;
  mergeTracks: Scalars['Boolean']['output'];
  prepareMobileTeamPurchase: MobileTeamPurchasePreparation;
  reauthorizeExternalLibrary: ExternalLibrary;
  refreshMobileUsageSummary: MobileUsageSummary;
  registerMSTeamWebhook: Array<MsTeamWebhook>;
  removeCustomSpecialtyTrainingData: CustomSpecialtyTrainingData;
  removeJobFromTeam: Scalars['Boolean']['output'];
  removeMSTeamWebhook: Scalars['Boolean']['output'];
  requestAgencySampleReportUpload: AgencySampleUploadTicket;
  requestCustomSpecialtyTrainingDataUpload: RequestCustomSpecialtyTrainingDataUploadPayload;
  resumeAgencySignupDraft: AgencySignupDraft;
  retryJob: RetryJobPayload;
  revertCustomSpecialtyPrompt: CustomSpecialty;
  reviseReport: Job;
  saveAgencySignupDraft: AgencySignupDraft;
  startJob: Job;
  startLiveJob: Job;
  stopLiveJob?: Maybe<Job>;
  submitAgencySignup: AgencySignupResult;
  updateAgencyDetails: AgencyTemplate;
  updateAgencyOfficer: AgencyTemplate;
  updateBookmarkList: BookmarkList;
  updateCustomSpecialty: CustomSpecialty;
  updateJob: Job;
  updateJobSource: Job;
  updateLiveJobSource: Job;
  updateMoment: Moment;
  updateNotificationsSubscription: NotificationsSubscription;
  updateOrganization: Organization;
  updateProfile: User;
  updateSpeaker: Speaker;
  updateTeam: Team;
  updateTeamInvitation: TeamInvitation;
  updateTeamMember: TeamMember;
  updateTeamMemberRole: TeamMember;
  updateTrack: Track;
  upgrade: User;
};


export type MutationActivateCustomSpecialtyArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAddAgencyOfficerArgs = {
  officer: AgencyOfficerRow;
  orgId: Scalars['ID']['input'];
};


export type MutationAddCommentArgs = {
  args: AddCommentInput;
};


export type MutationAddJobToTeamArgs = {
  jobId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationAddMomentArgs = {
  args: AddMomentInput;
};


export type MutationAddMomentLinkArgs = {
  source: MomentNodeInput;
  target: MomentNodeInput;
  type: Scalars['String']['input'];
};


export type MutationAddReactionArgs = {
  args: AddReactionInput;
};


export type MutationAddReplyArgs = {
  args: AddReplyInput;
};


export type MutationAddSpeakerArgs = {
  args: SpeakerAddInput;
};


export type MutationAddTrackArgs = {
  args: AddTrackInput;
};


export type MutationAddVideoTypeArgs = {
  videoType: Scalars['String']['input'];
};


export type MutationAdminAddOfficerToAgencyArgs = {
  officer: AgencyOfficerRow;
  orgId: Scalars['ID']['input'];
};


export type MutationAdminAddUserToTeamArgs = {
  email: Scalars['String']['input'];
  role: TeamMemberRoleInput;
  teamId: Scalars['ID']['input'];
};


export type MutationAdminCreateMachineClientArgs = {
  args: CreateMachineClientInput;
};


export type MutationAdminDeleteMachineClientArgs = {
  args: DeleteMachineClientInput;
};


export type MutationAdminHardDeleteAgencyArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationAdminSetDefaultJobSpecialityArgs = {
  id: Scalars['ID']['input'];
  speciality?: InputMaybe<JobSpeciality>;
};


export type MutationAdminSetOrgDefaultJobSpecialityArgs = {
  orgId: Scalars['ID']['input'];
  speciality?: InputMaybe<JobSpeciality>;
};


export type MutationAdminSyncAgencyLibrariesArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationAdminUpdateAgencyDetailsArgs = {
  details: AgencyDetailsInput;
  orgId: Scalars['ID']['input'];
};


export type MutationAdminUpdateAgencyOfficerArgs = {
  currentEmail: Scalars['AWSEmail']['input'];
  officer: AgencyOfficerRow;
  orgId: Scalars['ID']['input'];
};


export type MutationAdminUpdateAgencyReportDictionaryArgs = {
  expectedVersion: Scalars['Int']['input'];
  orgId: Scalars['ID']['input'];
  reportDictionary: Array<ReportDictionaryRuleInput>;
  specialtyId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAdminUpdateAgencySettingsArgs = {
  orgId: Scalars['ID']['input'];
  settings: AgencyOrganizationSettingsInput;
};


export type MutationAdminUpdateAgencyVocabularyArgs = {
  orgId: Scalars['ID']['input'];
  vocabulary: Array<VocabularyInput>;
};


export type MutationArchiveCustomSpecialtyArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationArchiveJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeJobOwnerArgs = {
  args: ChangeJobOwnerInput;
};


export type MutationCompleteMultipartUploadArgs = {
  input: CompleteMultipartUploadInput;
};


export type MutationConfirmAgencySampleReportUploadArgs = {
  orgId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
};


export type MutationConfirmCustomSpecialtyTrainingDataUploadArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  trainingDataId: Scalars['ID']['input'];
};


export type MutationConfirmSpeakerPredictionArgs = {
  args: ConfirmSpeakerPredictionInput;
};


export type MutationConnectExternalLibraryArgs = {
  input: ConnectExternalLibraryInput;
};


export type MutationCopyJobArgs = {
  jobId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateApiKeyArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAssetShareLinkArgs = {
  input: CreateAssetShareLinkInput;
};


export type MutationCreateBookmarkArgs = {
  jobId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
  momentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateBookmarkListArgs = {
  name: Scalars['ID']['input'];
};


export type MutationCreateCustomSpecialtyArgs = {
  args: CreateCustomSpecialtyInput;
};


export type MutationCreateMediaShortLinkArgs = {
  input: CreateMediaShortLinkInput;
};


export type MutationCreateMultipartUploadArgs = {
  input: CreateMultiPartUploadInput;
};


export type MutationCreateNotificationsSubscriptionArgs = {
  args: CreateNotificationSubscriptionInput;
};


export type MutationCreateOrganizationArgs = {
  args: OrganizationCreateInput;
};


export type MutationCreateTeamArgs = {
  args: TeamCreateInput;
};


export type MutationCreateVideoShortLinkArgs = {
  input: CreateVideoShortLinkInput;
};


export type MutationDeleteApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookmarkArgs = {
  bookmarkId: Scalars['ID']['input'];
  listId: Scalars['ID']['input'];
};


export type MutationDeleteBookmarkListArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};


export type MutationDeleteExternalLibraryArgs = {
  input: DeleteExternalLibraryInput;
};


export type MutationDeleteMomentArgs = {
  jobId: Scalars['ID']['input'];
  momentId: Scalars['ID']['input'];
};


export type MutationDeleteMomentLinkArgs = {
  source: MomentNodeInput;
  target: MomentNodeInput;
  type: Scalars['String']['input'];
};


export type MutationDeleteNotificationsSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationsSubscriptionSubscribedEventArgs = {
  args: DeleteNotificationsSubscriptionSubscribedEventInput;
};


export type MutationDeleteOpenidConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSpeakerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteTeamInvitationArgs = {
  email: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteTrackArgs = {
  jobId: Scalars['ID']['input'];
  trackId: Scalars['ID']['input'];
};


export type MutationDeleteVideoTypeArgs = {
  videoType: Scalars['String']['input'];
};


export type MutationDuplicateTrackArgs = {
  jobId: Scalars['ID']['input'];
  trackId: Scalars['ID']['input'];
};


export type MutationEditCommentArgs = {
  args: EditCommentInput;
};


export type MutationExportClipsArgs = {
  input: ExportClipsInput;
};


export type MutationExportJobArgs = {
  iamRole?: InputMaybe<IamRoleInput>;
  jobId: Scalars['String']['input'];
  location: Scalars['String']['input'];
};


export type MutationExportJobAssetArgs = {
  input: ExportJobAssetInput;
};


export type MutationExportTextEditorPdfArgs = {
  input: ExportTextEditorPdfInput;
};


export type MutationGenerateCustomSpecialtyPromptArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationGenerateDualPlusPublicSafetyReportArgs = {
  input: GenerateDualPlusPublicSafetyReportInput;
};


export type MutationGetAvatarUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationGetCoverUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationGetGptAnswerArgs = {
  input: GetGptAnswerInput;
};


export type MutationGetJobThumbnailUploadUrlArgs = {
  input: JobThumbnailUploadInput;
};


export type MutationGetLogoUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationGetProfilePictureUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationGetReportImageUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
};


export type MutationGetSpeakerPictureUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationImportJobArgs = {
  iamRole?: InputMaybe<IamRoleInput>;
  location: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationIncrementViewCountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInviteAgencyLibraryArgs = {
  officer: AgencyOfficerRow;
  orgId: Scalars['ID']['input'];
};


export type MutationInviteAllAgencyLibrariesArgs = {
  orgId: Scalars['ID']['input'];
};


export type MutationInviteTeamMemberArgs = {
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  role: TeamMemberRoleInput;
  skipEmail?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ID']['input'];
};


export type MutationJoinTeamByInvitationArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationLeaveTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationMergeTracksArgs = {
  jobId: Scalars['ID']['input'];
  sourceTrackId: Scalars['ID']['input'];
  targetTrackId: Scalars['ID']['input'];
};


export type MutationPrepareMobileTeamPurchaseArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationReauthorizeExternalLibraryArgs = {
  input: ReauthorizeExternalLibraryInput;
};


export type MutationRefreshMobileUsageSummaryArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterMsTeamWebhookArgs = {
  args: MsTeamWebhookInput;
};


export type MutationRemoveCustomSpecialtyTrainingDataArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  trainingDataId: Scalars['ID']['input'];
};


export type MutationRemoveJobFromTeamArgs = {
  jobId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationRemoveMsTeamWebhookArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationRequestAgencySampleReportUploadArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationRequestCustomSpecialtyTrainingDataUploadArgs = {
  args: RequestCustomSpecialtyTrainingDataUploadInput;
};


export type MutationResumeAgencySignupDraftArgs = {
  draftId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationRetryJobArgs = {
  input: RetryJobInput;
};


export type MutationRevertCustomSpecialtyPromptArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationReviseReportArgs = {
  input: ReviseReportInput;
};


export type MutationSaveAgencySignupDraftArgs = {
  email: Scalars['AWSEmail']['input'];
  payload: Scalars['AWSJSON']['input'];
};


export type MutationStartJobArgs = {
  args: StartJobInput;
};


export type MutationStartLiveJobArgs = {
  args: StartLiveJobInput;
};


export type MutationStopLiveJobArgs = {
  jobId: Scalars['ID']['input'];
  source?: InputMaybe<LiveStreamChannels>;
};


export type MutationSubmitAgencySignupArgs = {
  input: AgencySignupPayload;
};


export type MutationUpdateAgencyDetailsArgs = {
  details: AgencyDetailsInput;
  orgId: Scalars['ID']['input'];
};


export type MutationUpdateAgencyOfficerArgs = {
  currentEmail: Scalars['AWSEmail']['input'];
  officer: AgencyOfficerRow;
  orgId: Scalars['ID']['input'];
};


export type MutationUpdateBookmarkListArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateCustomSpecialtyArgs = {
  args: UpdateCustomSpecialtyInput;
};


export type MutationUpdateJobArgs = {
  args: UpdateJobInput;
};


export type MutationUpdateJobSourceArgs = {
  jobId: Scalars['ID']['input'];
  source: JobSourceInput;
  uploadToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLiveJobSourceArgs = {
  jobId: Scalars['ID']['input'];
  source: LiveJobSourceInput;
};


export type MutationUpdateMomentArgs = {
  args: UpdateMomentInput;
};


export type MutationUpdateNotificationsSubscriptionArgs = {
  args: UpdateNotificationSubscriptionInput;
};


export type MutationUpdateOrganizationArgs = {
  args: OrganizationUpdateInput;
};


export type MutationUpdateProfileArgs = {
  args?: InputMaybe<UpdateProfileInput>;
};


export type MutationUpdateSpeakerArgs = {
  args: SpeakerUpdateInput;
};


export type MutationUpdateTeamArgs = {
  args?: InputMaybe<TeamUpdateInput>;
};


export type MutationUpdateTeamInvitationArgs = {
  email: Scalars['String']['input'];
  role: TeamMemberRoleInput;
  teamId: Scalars['ID']['input'];
};


export type MutationUpdateTeamMemberArgs = {
  args: UpdateTeamMemberInput;
};


export type MutationUpdateTeamMemberRoleArgs = {
  role: TeamMemberRoleInput;
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateTrackArgs = {
  args: UpdateTrackInput;
};

export type NotificationSubscriptionEmailEventType = {
  __typename?: 'NotificationSubscriptionEmailEventType';
  name: Scalars['String']['output'];
  value: NotificationSubscriptionSubscribedEvent;
};

export const NotificationSubscriptionSubscribedEvent = {
  AgencySignupDraftResume: 'AgencySignupDraftResume',
  AgencySignupWelcome: 'AgencySignupWelcome',
  ClipsExport: 'ClipsExport',
  ComplianceReport: 'ComplianceReport',
  DualPlusReport: 'DualPlusReport',
  JobDone: 'JobDone',
  JobDownload: 'JobDownload',
  JobDownloadFailed: 'JobDownloadFailed',
  JobLiveEnded: 'JobLiveEnded',
  JobProgress: 'JobProgress',
  JobWaiting: 'JobWaiting',
  RevisionDigest: 'RevisionDigest',
  TeamInvitation: 'TeamInvitation',
  TeamIsPublic: 'TeamIsPublic',
  TrainerMessage: 'TrainerMessage',
  UploadProgress: 'UploadProgress',
  ZelloRecap: 'ZelloRecap'
} as const;

export type NotificationSubscriptionSubscribedEvent = typeof NotificationSubscriptionSubscribedEvent[keyof typeof NotificationSubscriptionSubscribedEvent];
export type NotificationsSubscription = {
  __typename?: 'NotificationsSubscription';
  destination: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subscribedEvents: Array<NotificationSubscriptionSubscribedEvent>;
  uploadProgressOptions?: Maybe<UploadProgressOptions>;
};

export type NotificationsSubscriptionConnection = {
  __typename?: 'NotificationsSubscriptionConnection';
  edges: Array<NotificationsSubscriptionEdge>;
  pageInfo: PageInfo;
};

export type NotificationsSubscriptionEdge = {
  __typename?: 'NotificationsSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node: NotificationsSubscription;
};

export type NumericRangeFilter = {
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenidConfig = {
  __typename?: 'OpenidConfig';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  kid: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  wellKnownUrl: Scalars['String']['output'];
};

export const Order = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type Order = typeof Order[keyof typeof Order];
export type Organization = {
  __typename?: 'Organization';
  customerFollowUpLetterEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultJobSpeciality?: Maybe<JobSpeciality>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  dualPlusEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  phoneticAddressNormalizationEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Agency-wide report terminology, applied to every Custom report produced under this org. Mirrors
   * the copy on a trained format's specialty row, and is the ONLY copy for an agency whose format was
   * trained through the Train wizard rather than the sponsor sample flow -- nothing registers a source
   * specialty on that path, so there is no specialty row for the agency editor to write to.
   */
  reportDictionary?: Maybe<Array<ReportDictionaryRule>>;
  /**
   * Bumped by every dictionary save. The editor captures it and hands it back, so a stale editor
   * cannot silently replace a newer save. Kept in lockstep with the source specialty's generation
   * when the agency has one, so the two rows can never disagree about which save is newer.
   */
  reportDictionaryVersion?: Maybe<Scalars['Int']['output']>;
  videoDisabled?: Maybe<Scalars['Boolean']['output']>;
  vocabulary?: Maybe<Array<Vocabulary>>;
};

export type OrganizationCreateInput = {
  defaultJobSpeciality?: InputMaybe<JobSpeciality>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  videoDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  createdAt: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  role: TeamMemberRole;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export const OrganizationMemberRole = {
  Admin: 'Admin',
  Member: 'Member',
  Owner: 'Owner'
} as const;

export type OrganizationMemberRole = typeof OrganizationMemberRole[keyof typeof OrganizationMemberRole];
export type OrganizationUpdateInput = {
  defaultJobSpeciality?: InputMaybe<JobSpeciality>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  videoDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  vocabulary?: InputMaybe<Array<VocabularyInput>>;
};

export const OutputReactionName = {
  Celebrate: 'Celebrate',
  Confusing: 'Confusing',
  Engaging: 'Engaging',
  Fire: 'Fire',
  Funny: 'Funny',
  Genius: 'Genius',
  Hot: 'Hot',
  Insightful: 'Insightful',
  Love: 'Love',
  Rocket: 'Rocket',
  Smart: 'Smart'
} as const;

export type OutputReactionName = typeof OutputReactionName[keyof typeof OutputReactionName];
export type Owner = {
  __typename?: 'Owner';
  team?: Maybe<Team>;
  user?: Maybe<User>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PresignedPost = {
  __typename?: 'PresignedPost';
  fields: Array<FormDataField>;
  uploadToken: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type ProtectedUrl = {
  __typename?: 'ProtectedUrl';
  cookieCredentials: Array<Cookie>;
  policy: SignaturePolicy;
  signedUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminGetAgency: AgencyAdminAgency;
  adminGetJobs: JobConnection;
  adminGetProfile?: Maybe<User>;
  adminGetUserOrganization?: Maybe<Organization>;
  adminListAgencies: AgencyAdminSummaryConnection;
  adminListAgenciesWithoutLibraries: Array<AgencyAdminSummary>;
  batchGetSpeakers: Array<Maybe<Speaker>>;
  getAgencyOfficerStats: Array<AgencyOfficerStat>;
  getAgencyTemplateByDomain?: Maybe<AgencyTemplate>;
  getApiKeys: ApiKeyConnection;
  getBookmarkList: BookmarkList;
  getBookmarkLists: Array<BookmarkList>;
  getBookmarks: BookmarkConnection;
  getComments: CommentConnection;
  getCustomSpecialties: Array<CustomSpecialty>;
  getCustomSpecialty?: Maybe<CustomSpecialty>;
  getCustomSpecialtyTrainingData: Array<CustomSpecialtyTrainingData>;
  getDownloadLink: Scalars['Boolean']['output'];
  getInvitations: Array<TeamInvitation>;
  getJob?: Maybe<Job>;
  getJobBookmarks: BookmarkConnection;
  getJobLanguages: Array<Maybe<JobLanguage>>;
  getJobPermissions: Array<Maybe<JobPermission>>;
  getJobRelatedBookmarks: BookmarkConnection;
  /**
   * The page furniture to draw on a job's report: the job's own report format when it has one,
   * otherwise the identity (letterhead, footer, typeface) of the agency that owns its library.
   *
   * Job-scoped on purpose. Asking what branding a *specialty* has means a job without one is
   * unbrandable, which is how a branded agency's Patrol drafts came out plain.
   */
  getJobReportBranding?: Maybe<ReportBranding>;
  getJobTranscript: TranscriptDownload;
  getJobs: JobConnection;
  getMachineClients: Array<MachineClient>;
  getMobileUsageSummary: MobileUsageSummary;
  getMoment: Moment;
  getMomentBookmarks: BookmarkConnection;
  getMomentLinks: MomentLinkConnection;
  getMoments: MomentConnection;
  getNotificationSubscriptionEmailEventTypes: Array<NotificationSubscriptionEmailEventType>;
  getNotificationsSubscription: NotificationsSubscription;
  getNotificationsSubscriptions: NotificationsSubscriptionConnection;
  getOpenidConfig?: Maybe<OpenidConfig>;
  getOrganizationByDomain?: Maybe<Organization>;
  getOrganizationByName?: Maybe<Organization>;
  getOriginalDocument: TranslatedDocumentPayload;
  getProfile: User;
  getReactions: CommentConnection;
  getSettings: Settings;
  getSpeaker: Speaker;
  getSpeakers: Array<Maybe<Speaker>>;
  getTeam: Team;
  getTeamInvitations: TeamInvitationConnection;
  getTeamMembers: TeamMemberConnection;
  getTeamNamespaces?: Maybe<Array<Maybe<TeamNamespace>>>;
  getTeamTags?: Maybe<Array<Maybe<TeamTag>>>;
  getTeams: TeamConnection;
  getTracks: Array<Track>;
  getTranslatedDocument: TranslatedDocumentPayload;
  getUploadUrl: PresignedPost;
  keenBatch: KeenBatchResult;
  keenQuery: KeenQueryResult;
  retrieveDeceptioAiAnalysis: DeceptioAiDetailedAnalysis;
  searchMoments: SearchMomentConnection;
  shareableAssets: ShareableAssets;
  viewer?: Maybe<Viewer>;
};


export type QueryAdminGetAgencyArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryAdminGetJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminGetJobsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminGetJobsSortInput>;
};


export type QueryAdminGetProfileArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminGetUserOrganizationArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAdminListAgenciesArgs = {
  filter?: InputMaybe<AgencyAdminListFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AgencyAdminListSortInput>;
};


export type QueryBatchGetSpeakersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetAgencyOfficerStatsArgs = {
  orgId: Scalars['ID']['input'];
};


export type QueryGetAgencyTemplateByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetApiKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBookmarkListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBookmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  listId: Scalars['ID']['input'];
};


export type QueryGetCommentsArgs = {
  args: GetCommentsInput;
};


export type QueryGetCustomSpecialtiesArgs = {
  status?: InputMaybe<CustomSpecialtyStatus>;
  teamId: Scalars['ID']['input'];
};


export type QueryGetCustomSpecialtyArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetCustomSpecialtyTrainingDataArgs = {
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type QueryGetDownloadLinkArgs = {
  args: GetDownloadLinkInput;
};


export type QueryGetJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetJobBookmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
};


export type QueryGetJobPermissionsArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetJobRelatedBookmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
};


export type QueryGetJobReportBrandingArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetJobTranscriptArgs = {
  format: TranscriptFormat;
  jobId: Scalars['ID']['input'];
};


export type QueryGetJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetJobsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GetJobsSortInput>;
};


export type QueryGetMobileUsageSummaryArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMomentArgs = {
  jobId: Scalars['ID']['input'];
  momentId: Scalars['ID']['input'];
  sizes?: InputMaybe<Array<ImageSize>>;
};


export type QueryGetMomentBookmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['String']['input'];
  momentId: Scalars['String']['input'];
};


export type QueryGetMomentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  momentNode: MomentNodeInput;
};


export type QueryGetMomentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  clientApp?: InputMaybe<ClientApp>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
};


export type QueryGetNotificationsSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetNotificationsSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetNotificationsSubscriptionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetOrganizationByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetOrganizationByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetOriginalDocumentArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetReactionsArgs = {
  args: GetReactionsInput;
};


export type QueryGetSpeakerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSpeakersArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTeamInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetInvitationsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  sort?: InputMaybe<GetInvitationsSortInput>;
};


export type QueryGetTeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetTeamMembersFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  sort?: InputMaybe<GetTeamMembersSortInput>;
};


export type QueryGetTeamTagsArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetTeamsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GetTeamsSortInput>;
};


export type QueryGetTracksArgs = {
  clientApp?: InputMaybe<ClientApp>;
  jobId: Scalars['ID']['input'];
};


export type QueryGetTranslatedDocumentArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryGetUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  partIndex?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryKeenBatchArgs = {
  args: KeenBatchInput;
};


export type QueryKeenQueryArgs = {
  args: KeenQueryInput;
};


export type QueryRetrieveDeceptioAiAnalysisArgs = {
  jobId: Scalars['ID']['input'];
  momentId: Scalars['ID']['input'];
};


export type QuerySearchMomentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchMomentsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShareableAssetsArgs = {
  jobId: Scalars['ID']['input'];
};

export type ReauthorizeExternalLibraryInput = {
  authorizationCode: Scalars['String']['input'];
  externalLibraryId: Scalars['ID']['input'];
  redirectUri: Scalars['String']['input'];
};

export type RedactionObjects = {
  __typename?: 'RedactionObjects';
  computerScreen?: Maybe<Scalars['Boolean']['output']>;
  licensePlate?: Maybe<Scalars['Boolean']['output']>;
};

export type RedactionObjectsInput = {
  computerScreen?: InputMaybe<Scalars['Boolean']['input']>;
  licensePlate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedactionRequest = {
  __typename?: 'RedactionRequest';
  audioRedactions?: Maybe<Array<TimeRange>>;
  blankScreenRedactions?: Maybe<Array<TimeRange>>;
  id: Scalars['Int']['output'];
  objects?: Maybe<RedactionObjects>;
  returnUrl?: Maybe<Scalars['String']['output']>;
  selectAllFaces?: Maybe<Scalars['Boolean']['output']>;
  selectedFaces?: Maybe<Array<SelectedFace>>;
  useFfmpegBlur?: Maybe<Scalars['Boolean']['output']>;
};

export type RedactionRequestInput = {
  audioRedactions?: InputMaybe<Array<TimeRangeInput>>;
  blankScreenRedactions?: InputMaybe<Array<TimeRangeInput>>;
  id: Scalars['Int']['input'];
  objects?: InputMaybe<RedactionObjectsInput>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  selectAllFaces?: InputMaybe<Scalars['Boolean']['input']>;
  selectedFaces?: InputMaybe<Array<SelectedFaceInput>>;
  useFfmpegBlur?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportBranding = {
  __typename?: 'ReportBranding';
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  footerHtml?: Maybe<Scalars['String']['output']>;
  logoInches?: Maybe<ReportSizeInches>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  pageMarginInches?: Maybe<ReportPageMargins>;
  pageSizeInches?: Maybe<ReportSizeInches>;
};

export type ReportDictionaryRule = {
  __typename?: 'ReportDictionaryRule';
  sources: Array<Scalars['String']['output']>;
  target: Scalars['String']['output'];
};

export type ReportDictionaryRuleInput = {
  sources: Array<Scalars['String']['input']>;
  target: Scalars['String']['input'];
};

export type ReportImageUpload = {
  __typename?: 'ReportImageUpload';
  fields: Array<FormDataField>;
  signedUrl: Scalars['String']['output'];
  uploadToken: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type ReportPageMargins = {
  __typename?: 'ReportPageMargins';
  bottom: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  right: Scalars['Float']['output'];
  top: Scalars['Float']['output'];
};

export type ReportQuoteIssue = {
  __typename?: 'ReportQuoteIssue';
  /** The nearest transcript wording, when one is recognisably the same sentence. */
  closest?: Maybe<Scalars['String']['output']>;
  /** The quotation as it appears in the report. */
  quote: Scalars['String']['output'];
};

export type ReportSizeInches = {
  __typename?: 'ReportSizeInches';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type RequestCustomSpecialtyTrainingDataUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  role: CustomSpecialtyTrainingDataRole;
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type RequestCustomSpecialtyTrainingDataUploadPayload = {
  __typename?: 'RequestCustomSpecialtyTrainingDataUploadPayload';
  trainingData: CustomSpecialtyTrainingData;
  uploadFields: Array<FormDataField>;
  uploadUrl: Scalars['String']['output'];
};

export type ResizedImage = {
  __typename?: 'ResizedImage';
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type RetryJobInput = {
  forceRedownload?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type RetryJobPayload = {
  __typename?: 'RetryJobPayload';
  job: Job;
};

export type ReviseReportInput = {
  feedback: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
};

export type SearchMoment = {
  __typename?: 'SearchMoment';
  clipType: ClipType;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  jobId: Scalars['ID']['output'];
  momentType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Array<ResizedImage>>;
};


export type SearchMomentThumbnailArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type SearchMomentConnection = {
  __typename?: 'SearchMomentConnection';
  edges: Array<SearchMomentEdge>;
  pageInfo: PageInfo;
};

export type SearchMomentEdge = {
  __typename?: 'SearchMomentEdge';
  cursor: Scalars['String']['output'];
  highlights?: Maybe<Array<Highlight>>;
  node: SearchMoment;
};

export type SearchMomentsFilterInput = {
  _search?: InputMaybe<Scalars['String']['input']>;
  clientApp?: InputMaybe<ClientApp>;
  clipType?: InputMaybe<MomentTypeFilterInput>;
  metadata?: InputMaybe<Array<MetadataFilterInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type SelectedFace = {
  __typename?: 'SelectedFace';
  frameNumber: Scalars['Int']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  timeSeconds: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SelectedFaceInput = {
  frameNumber: Scalars['Int']['input'];
  height: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  thumbnailUrl: Scalars['String']['input'];
  timeSeconds: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Settings = {
  __typename?: 'Settings';
  videoTypes: Array<Scalars['String']['output']>;
};

export const ShareableAssetType = {
  Audio: 'AUDIO',
  Notes: 'NOTES',
  Report: 'REPORT',
  Transcript: 'TRANSCRIPT',
  Video: 'VIDEO'
} as const;

export type ShareableAssetType = typeof ShareableAssetType[keyof typeof ShareableAssetType];
export type ShareableAssets = {
  __typename?: 'ShareableAssets';
  assets: Array<ShareableAssetType>;
};

export type SignaturePolicy = {
  __typename?: 'SignaturePolicy';
  expiresAt: Scalars['AWSDateTime']['output'];
  expiresIn: Scalars['Int']['output'];
  resource: Scalars['String']['output'];
};

export type Speaker = {
  __typename?: 'Speaker';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNonSpeech?: Maybe<Scalars['Boolean']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  picture?: Maybe<Array<ResizedImage>>;
  prediction?: Maybe<SpeakerPrediction>;
  scope?: Maybe<Scalars['String']['output']>;
};


export type SpeakerPictureArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type SpeakerAddInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type SpeakerConnection = {
  __typename?: 'SpeakerConnection';
  edges: Array<SpeakerEdge>;
  pageInfo: PageInfo;
};

export type SpeakerEdge = {
  __typename?: 'SpeakerEdge';
  cursor: Scalars['String']['output'];
  node: Speaker;
};

export type SpeakerPrediction = {
  __typename?: 'SpeakerPrediction';
  probability: Scalars['Float']['output'];
  speaker?: Maybe<Speaker>;
  speakerId: Scalars['ID']['output'];
};

export type SpeakerUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pictureToken?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type StartJobFeaturesInput = {
  automaticEnrichment: Scalars['Boolean']['input'];
  manualEnrichment: Scalars['Boolean']['input'];
  media: Scalars['Boolean']['input'];
  transcript: Scalars['Boolean']['input'];
};

export type StartJobInput = {
  addToTeam?: InputMaybe<Array<Scalars['String']['input']>>;
  customSpecialtyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detectiveInsights?: InputMaybe<Scalars['String']['input']>;
  estimatedDurationMs?: InputMaybe<Scalars['Float']['input']>;
  estimatedMediaType?: InputMaybe<MobileMediaType>;
  features?: InputMaybe<StartJobFeaturesInput>;
  forceDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Industry>;
  inputDocumentLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputRecordingLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  medicalSpecialty?: InputMaybe<MedicalSpecialty>;
  metadata?: InputMaybe<MetadataInput>;
  notificationEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  posterToken?: InputMaybe<Scalars['String']['input']>;
  publicSafetyCaseId?: InputMaybe<Scalars['String']['input']>;
  publicSafetyOfficerName?: InputMaybe<Scalars['String']['input']>;
  publicSafetyOfficerTitle?: InputMaybe<Scalars['String']['input']>;
  redactionRequest?: InputMaybe<RedactionRequestInput>;
  source: JobSourceInput;
  sourceLanguageCode?: InputMaybe<Scalars['String']['input']>;
  speciality?: InputMaybe<JobSpeciality>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLanguageCode?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uploadToken?: InputMaybe<Scalars['String']['input']>;
  videoType?: InputMaybe<JobType>;
};

export type StartLiveJobInput = {
  addToTeam?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<StartJobFeaturesInput>;
  forceDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Industry>;
  ingestType?: InputMaybe<LiveStreamIngestType>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  medicalSpecialty?: InputMaybe<MedicalSpecialty>;
  metadata?: InputMaybe<MetadataInput>;
  posterToken?: InputMaybe<Scalars['String']['input']>;
  scheduledDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  source?: InputMaybe<LiveJobSourceInput>;
  speciality?: InputMaybe<JobSpeciality>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  videoType?: InputMaybe<JobType>;
};

export type Subscription = {
  __typename?: 'Subscription';
  addedComment?: Maybe<Comment>;
  deletedComment?: Maybe<DeleteCommentResponse>;
};


export type SubscriptionAddedCommentArgs = {
  jobId: Scalars['ID']['input'];
};


export type SubscriptionDeletedCommentArgs = {
  jobId: Scalars['ID']['input'];
};

export type Team = {
  __typename?: 'Team';
  acl?: Maybe<Array<TeamAcl>>;
  adTagUrls?: Maybe<Array<Scalars['String']['output']>>;
  autoJoinOnSignup?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<Array<ResizedImage>>;
  cover?: Maybe<Array<ResizedImage>>;
  customRedirectUrl?: Maybe<Scalars['String']['output']>;
  deceptioAiEnabled?: Maybe<Scalars['Boolean']['output']>;
  defaultCustomSpecialtyId?: Maybe<Scalars['ID']['output']>;
  defaultJobSpeciality?: Maybe<JobSpeciality>;
  defaultTranscriptLanguage?: Maybe<Scalars['String']['output']>;
  defaultTranslationLanguage?: Maybe<Scalars['String']['output']>;
  defaultVocabulary?: Maybe<Array<Vocabulary>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayOptions?: Maybe<TeamDisplayOptions>;
  displaySortOrder?: Maybe<Scalars['Boolean']['output']>;
  dualPlusActive: Scalars['Boolean']['output'];
  dualPlusEnabled?: Maybe<Scalars['Boolean']['output']>;
  externalEmail?: Maybe<Scalars['String']['output']>;
  generativeAiSettings?: Maybe<GenerativeAiSettings>;
  hideUserDetails?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  isPublicAuthor?: Maybe<Scalars['ID']['output']>;
  jobFeatures?: Maybe<TeamJobFeatures>;
  lastUploadAt?: Maybe<Scalars['AWSDateTime']['output']>;
  logo?: Maybe<Array<ResizedImage>>;
  membersCount?: Maybe<Scalars['Int']['output']>;
  metadataFields?: Maybe<Metadata>;
  name: Scalars['String']['output'];
  namespace?: Maybe<Scalars['String']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  publicSafety?: Maybe<Scalars['Boolean']['output']>;
  sendVideoProcessedNotificationToAllMembers?: Maybe<Scalars['Boolean']['output']>;
  showCover?: Maybe<Scalars['Boolean']['output']>;
  showLogo?: Maybe<Scalars['Boolean']['output']>;
  speakerSuggest?: Maybe<TeamSpeakerSuggest>;
  teamProduct?: Maybe<TeamProduct>;
  uploadsCount?: Maybe<Scalars['Int']['output']>;
  userPermissions?: Maybe<Array<UserTeamPermission>>;
  vocabulary?: Maybe<Array<Vocabulary>>;
};


export type TeamAvatarArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};


export type TeamCoverArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};


export type TeamLogoArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type TeamAcl = {
  __typename?: 'TeamAcl';
  organizationId?: Maybe<Scalars['ID']['output']>;
  roles: Array<TeamMemberRole>;
  tokenNamespace?: Maybe<Scalars['String']['output']>;
};

export type TeamAclInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  roles: Array<TeamMemberRole>;
  tokenNamespace?: InputMaybe<Scalars['String']['input']>;
};

export type TeamAnalyticsExclude = {
  add?: InputMaybe<Scalars['ID']['input']>;
  remove?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  edges: Array<TeamEdge>;
  pageInfo: PageInfo;
};

export type TeamCreateInput = {
  acl?: InputMaybe<Array<TeamAclInput>>;
  adTagUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  autoJoinOnSignup?: InputMaybe<Scalars['Boolean']['input']>;
  customRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  defaultCustomSpecialtyId?: InputMaybe<Scalars['ID']['input']>;
  defaultJobSpeciality?: InputMaybe<JobSpeciality>;
  defaultTranscriptLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultTranslationLanguage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOptions?: InputMaybe<TeamDisplayOptionsInput>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  generativeAiSettings?: InputMaybe<GenerativeAiSettingsInput>;
  hasSpeakerSuggest?: InputMaybe<Scalars['Boolean']['input']>;
  hideUserDetails?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Industry>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  jobFeatures?: InputMaybe<StartJobFeaturesInput>;
  metadataFields?: InputMaybe<MetadataInput>;
  name: Scalars['String']['input'];
  teamProduct?: InputMaybe<TeamProduct>;
};

export type TeamDisplayOptions = {
  __typename?: 'TeamDisplayOptions';
  galleryDisplay?: Maybe<GalleryDisplay>;
  theme?: Maybe<Theme>;
};

export type TeamDisplayOptionsInput = {
  galleryDisplay?: InputMaybe<GalleryDisplay>;
  theme?: InputMaybe<Theme>;
};

export type TeamEdge = {
  __typename?: 'TeamEdge';
  cursor: Scalars['String']['output'];
  node: Team;
};

export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  role: TeamMemberRole;
  teamId: Scalars['ID']['output'];
};

export type TeamInvitationConnection = {
  __typename?: 'TeamInvitationConnection';
  edges: Array<TeamInvitationEdge>;
  pageInfo: PageInfo;
};

export type TeamInvitationEdge = {
  __typename?: 'TeamInvitationEdge';
  cursor: Scalars['String']['output'];
  node: TeamInvitation;
};

export type TeamJobFeatures = {
  __typename?: 'TeamJobFeatures';
  automaticEnrichment: Scalars['Boolean']['output'];
  manualEnrichment: Scalars['Boolean']['output'];
  media: Scalars['Boolean']['output'];
  transcript: Scalars['Boolean']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt: Scalars['String']['output'];
  role: TeamMemberRole;
  teamId: Scalars['ID']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type TeamMemberConnection = {
  __typename?: 'TeamMemberConnection';
  edges: Array<TeamMemberEdge>;
  pageInfo: PageInfo;
};

export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  cursor: Scalars['String']['output'];
  node: TeamMember;
};

export const TeamMemberRole = {
  Admin: 'Admin',
  Member: 'Member',
  Owner: 'Owner',
  Trainer: 'Trainer',
  Viewer: 'Viewer'
} as const;

export type TeamMemberRole = typeof TeamMemberRole[keyof typeof TeamMemberRole];
export const TeamMemberRoleInput = {
  Admin: 'Admin',
  Member: 'Member',
  Trainer: 'Trainer',
  Viewer: 'Viewer'
} as const;

export type TeamMemberRoleInput = typeof TeamMemberRoleInput[keyof typeof TeamMemberRoleInput];
export const TeamMembersByOption = {
  Email: 'email',
  Name: 'name',
  Role: 'role',
  Username: 'username'
} as const;

export type TeamMembersByOption = typeof TeamMembersByOption[keyof typeof TeamMembersByOption];
export type TeamNamespace = {
  __typename?: 'TeamNamespace';
  count: Scalars['Int']['output'];
  namespace: Scalars['String']['output'];
};

export const TeamOrderByOption = {
  LastUploadAt: 'lastUploadAt',
  MembersCount: 'membersCount',
  Name: 'name',
  OwnerEmail: 'ownerEmail',
  OwnerName: 'ownerName',
  Score: 'score',
  TeamProduct: 'teamProduct',
  UploadsCount: 'uploadsCount'
} as const;

export type TeamOrderByOption = typeof TeamOrderByOption[keyof typeof TeamOrderByOption];
export const TeamProduct = {
  Premium: 'Premium',
  Pro: 'Pro',
  Standard: 'Standard'
} as const;

export type TeamProduct = typeof TeamProduct[keyof typeof TeamProduct];
export type TeamSpeakerSuggest = {
  __typename?: 'TeamSpeakerSuggest';
  enabled: Scalars['Boolean']['output'];
  status?: Maybe<TeamSpeakerSuggestStatus>;
};

export const TeamSpeakerSuggestStatus = {
  Done: 'Done',
  Failed: 'Failed',
  Processing: 'Processing'
} as const;

export type TeamSpeakerSuggestStatus = typeof TeamSpeakerSuggestStatus[keyof typeof TeamSpeakerSuggestStatus];
export type TeamTag = {
  __typename?: 'TeamTag';
  count: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type TeamUpdateInput = {
  acl?: InputMaybe<Array<TeamAclInput>>;
  adTagUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  autoJoinOnSignup?: InputMaybe<Scalars['Boolean']['input']>;
  avatarToken?: InputMaybe<Scalars['String']['input']>;
  coverToken?: InputMaybe<Scalars['String']['input']>;
  customRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  deceptioAiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCustomSpecialtyId?: InputMaybe<Scalars['ID']['input']>;
  defaultJobSpeciality?: InputMaybe<JobSpeciality>;
  defaultTranscriptLanguage?: InputMaybe<Scalars['String']['input']>;
  defaultTranslationLanguage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayOptions?: InputMaybe<TeamDisplayOptionsInput>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  generativeAiSettings?: InputMaybe<GenerativeAiSettingsInput>;
  hasSpeakerSuggest?: InputMaybe<Scalars['Boolean']['input']>;
  hideUserDetails?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Industry>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  jobFeatures?: InputMaybe<StartJobFeaturesInput>;
  logoToken?: InputMaybe<Scalars['String']['input']>;
  metadataFields?: InputMaybe<MetadataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendVideoProcessedNotificationToAllMembers?: InputMaybe<Scalars['Boolean']['input']>;
  showCover?: InputMaybe<Scalars['Boolean']['input']>;
  showLogo?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ID']['input'];
  teamProduct?: InputMaybe<TeamProduct>;
  vocabulary?: InputMaybe<Array<VocabularyInput>>;
};

export const Theme = {
  Dark: 'Dark',
  Light: 'Light'
} as const;

export type Theme = typeof Theme[keyof typeof Theme];
export type TimeRange = {
  __typename?: 'TimeRange';
  endSeconds: Scalars['Float']['output'];
  startSeconds: Scalars['Float']['output'];
};

export type TimeRangeInput = {
  endSeconds: Scalars['Float']['input'];
  startSeconds: Scalars['Float']['input'];
};

export type Track = {
  __typename?: 'Track';
  id: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
  languageCode?: Maybe<Scalars['String']['output']>;
  momentType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  speakerId?: Maybe<Scalars['ID']['output']>;
  type: ClipType;
  visibleToConsumer: Scalars['Boolean']['output'];
};

export type TrackConnection = {
  __typename?: 'TrackConnection';
  edges: Array<TrackEdge>;
  pageInfo: PageInfo;
};

export type TrackEdge = {
  __typename?: 'TrackEdge';
  cursor: Scalars['String']['output'];
  node: Track;
};

export type TranscriptDownload = {
  __typename?: 'TranscriptDownload';
  url: Scalars['String']['output'];
};

export const TranscriptFormat = {
  Rtf: 'RTF',
  Txt: 'TXT'
} as const;

export type TranscriptFormat = typeof TranscriptFormat[keyof typeof TranscriptFormat];
export type TranslatedDocumentPayload = {
  __typename?: 'TranslatedDocumentPayload';
  contentType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type UpdateCustomSpecialtyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  specialtyId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type UpdateJobFeaturesInput = {
  automaticEnrichment: Scalars['Boolean']['input'];
  manualEnrichment: Scalars['Boolean']['input'];
  media: Scalars['Boolean']['input'];
  transcript: Scalars['Boolean']['input'];
};

export type UpdateJobInput = {
  deceptioSpeakerId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<UpdateJobFeaturesInput>;
  id: Scalars['ID']['input'];
  industry?: InputMaybe<Industry>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  medicalSpecialty?: InputMaybe<MedicalSpecialty>;
  metadata?: InputMaybe<MetadataInput>;
  posterToken?: InputMaybe<Scalars['String']['input']>;
  publicSafetyCaseId?: InputMaybe<Scalars['String']['input']>;
  publicSafetyCustomerFollowUpLetter?: InputMaybe<Scalars['String']['input']>;
  publicSafetyDualPlusReport?: InputMaybe<Scalars['String']['input']>;
  publicSafetyManualReport?: InputMaybe<Scalars['String']['input']>;
  publicSafetyNotes?: InputMaybe<Scalars['String']['input']>;
  publicSafetyNotesFeedback?: InputMaybe<Scalars['String']['input']>;
  publicSafetyOfficerName?: InputMaybe<Scalars['String']['input']>;
  publicSafetyOfficerTitle?: InputMaybe<Scalars['String']['input']>;
  publicSafetyReport?: InputMaybe<Scalars['String']['input']>;
  publicSafetyReportComplete?: InputMaybe<Scalars['Boolean']['input']>;
  publicSafetyReportFeedback?: InputMaybe<Scalars['String']['input']>;
  scheduledDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<JobStatusUpdateOptions>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  translatedDocumentContent?: InputMaybe<Scalars['String']['input']>;
  videoType?: InputMaybe<JobType>;
};

export type UpdateMomentInput = {
  clipType: ClipType;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  importance?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  momentId: Scalars['ID']['input'];
  momentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MomentSourceInput>;
  speakerId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  trackId?: InputMaybe<Scalars['ID']['input']>;
  visibleToConsumer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationSubscriptionInput = {
  id: Scalars['ID']['input'];
  subscribedEvents?: InputMaybe<Array<InputMaybe<NotificationSubscriptionSubscribedEvent>>>;
  uploadProgressOptions?: InputMaybe<UploadProgressOptionsInput>;
};

export type UpdateProfileInput = {
  avatarToken?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  generativeAiSettings?: InputMaybe<GenerativeAiSettingsInput>;
  hideSpeakerSuggestion?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isFoundingMember?: InputMaybe<Scalars['Boolean']['input']>;
  jobFunction?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  showOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  showPlayerTutorial?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamMemberInput = {
  teamAnalytics?: InputMaybe<TeamAnalyticsExclude>;
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateTrackInput = {
  jobId: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  momentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  speakerId?: InputMaybe<Scalars['ID']['input']>;
  trackId: Scalars['ID']['input'];
  type?: InputMaybe<ClipType>;
  visibleToConsumer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadProgressOptions = {
  __typename?: 'UploadProgressOptions';
  includePartUpdates?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadProgressOptionsInput = {
  includePartUpdates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  adminDefaultJobSpeciality?: Maybe<JobSpeciality>;
  avatar?: Maybe<Array<ResizedImage>>;
  companySize?: Maybe<Scalars['String']['output']>;
  defaultJobSpeciality?: Maybe<JobSpeciality>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  generativeAiSettings?: Maybe<GenerativeAiSettings>;
  hideSpeakerSuggestions?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isFoundingMember?: Maybe<Scalars['Boolean']['output']>;
  jobFunction?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<UserPermission>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showOnboarding?: Maybe<Scalars['Boolean']['output']>;
  showPlayerTutorial?: Maybe<Scalars['Boolean']['output']>;
  teamAnalyticsExclude?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  userNotificationSubscriptions?: Maybe<NotificationsSubscriptionConnection>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserAvatarArgs = {
  sizes?: InputMaybe<Array<ImageSize>>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export const UserJobPermission = {
  AddComment: 'AddComment',
  Delete: 'Delete',
  Edit: 'Edit',
  EditIsPublic: 'EditIsPublic',
  EditTrainerMoment: 'EditTrainerMoment',
  EditTrainerTrack: 'EditTrainerTrack',
  EditUserMoment: 'EditUserMoment',
  EditUserTrack: 'EditUserTrack',
  RemoveFromTeam: 'RemoveFromTeam',
  View: 'View'
} as const;

export type UserJobPermission = typeof UserJobPermission[keyof typeof UserJobPermission];
export const UserMomentPermission = {
  Edit: 'Edit',
  View: 'View'
} as const;

export type UserMomentPermission = typeof UserMomentPermission[keyof typeof UserMomentPermission];
export const UserPermission = {
  AddTeamTrainer: 'AddTeamTrainer',
  AdminGetTeams: 'AdminGetTeams',
  AdminManageAgencies: 'AdminManageAgencies',
  BulkInviteTeammates: 'BulkInviteTeammates',
  ChangeOwner: 'ChangeOwner',
  CreateJob: 'CreateJob',
  CreateTeam: 'CreateTeam',
  UpdateSpeaker: 'UpdateSpeaker',
  ViewAnalytics: 'ViewAnalytics',
  ViewTrainerDashboard: 'ViewTrainerDashboard'
} as const;

export type UserPermission = typeof UserPermission[keyof typeof UserPermission];
export type UserStub = {
  __typename?: 'UserStub';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export const UserTeamPermission = {
  AddJob: 'AddJob',
  ConfirmSpeakerPrediction: 'ConfirmSpeakerPrediction',
  CreateJob: 'CreateJob',
  DeleteTeam: 'DeleteTeam',
  EditTeam: 'EditTeam',
  RemoveJob: 'RemoveJob',
  ViewAnalytics: 'ViewAnalytics',
  ViewPrivateJob: 'ViewPrivateJob',
  ViewTeam: 'ViewTeam'
} as const;

export type UserTeamPermission = typeof UserTeamPermission[keyof typeof UserTeamPermission];
export type VideoShortLink = {
  __typename?: 'VideoShortLink';
  url: Scalars['String']['output'];
};

export type Viewer = {
  __typename?: 'Viewer';
  externalLibraries: Array<ExternalLibrary>;
  externalLibrary: ExternalLibrary;
  id: Scalars['String']['output'];
};


export type ViewerExternalLibraryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type Vocabulary = {
  __typename?: 'Vocabulary';
  displayAs?: Maybe<Scalars['String']['output']>;
  phrase: Scalars['String']['output'];
  soundsLike?: Maybe<Scalars['String']['output']>;
};

export type VocabularyInput = {
  displayAs?: InputMaybe<Scalars['String']['input']>;
  phrase: Scalars['String']['input'];
  soundsLike?: InputMaybe<Scalars['String']['input']>;
};

export const WatchMode = {
  Live: 'Live',
  Static: 'Static'
} as const;

export type WatchMode = typeof WatchMode[keyof typeof WatchMode];